import { formatEnglishDiagnostic } from "@doenet/i18n";
function codedDiagnostic({
  type,
  code,
  args,
  position,
  sourceDoc,
  level
}) {
  return {
    type,
    message: formatEnglishDiagnostic(code, args),
    code,
    ...args === void 0 ? {} : { args },
    ...position === void 0 ? {} : { position },
    ...sourceDoc === void 0 ? {} : { sourceDoc },
    ...level === void 0 ? {} : { level }
  };
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var colorName$1;
var hasRequiredColorName;
function requireColorName() {
  if (hasRequiredColorName) return colorName$1;
  hasRequiredColorName = 1;
  colorName$1 = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
  };
  return colorName$1;
}
var colorNameExports = requireColorName();
const colorName = /* @__PURE__ */ getDefaultExportFromCjs(colorNameExports);
var r$2 = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, t$3 = function(r2) {
  return "string" == typeof r2 ? r2.length > 0 : "number" == typeof r2;
}, n$2 = function(r2, t2, n2) {
  return void 0 === t2 && (t2 = 0), void 0 === n2 && (n2 = Math.pow(10, t2)), Math.round(n2 * r2) / n2 + 0;
}, e$2 = function(r2, t2, n2) {
  return void 0 === t2 && (t2 = 0), void 0 === n2 && (n2 = 1), r2 > n2 ? n2 : r2 > t2 ? r2 : t2;
}, u$2 = function(r2) {
  return (r2 = isFinite(r2) ? r2 % 360 : 0) > 0 ? r2 : r2 + 360;
}, a$2 = function(r2) {
  return { r: e$2(r2.r, 0, 255), g: e$2(r2.g, 0, 255), b: e$2(r2.b, 0, 255), a: e$2(r2.a) };
}, o$3 = function(r2) {
  return { r: n$2(r2.r), g: n$2(r2.g), b: n$2(r2.b), a: n$2(r2.a, 3) };
}, i$2 = /^#([0-9a-f]{3,8})$/i, s$1 = function(r2) {
  var t2 = r2.toString(16);
  return t2.length < 2 ? "0" + t2 : t2;
}, h$2 = function(r2) {
  var t2 = r2.r, n2 = r2.g, e2 = r2.b, u2 = r2.a, a2 = Math.max(t2, n2, e2), o2 = a2 - Math.min(t2, n2, e2), i2 = o2 ? a2 === t2 ? (n2 - e2) / o2 : a2 === n2 ? 2 + (e2 - t2) / o2 : 4 + (t2 - n2) / o2 : 0;
  return { h: 60 * (i2 < 0 ? i2 + 6 : i2), s: a2 ? o2 / a2 * 100 : 0, v: a2 / 255 * 100, a: u2 };
}, b$2 = function(r2) {
  var t2 = r2.h, n2 = r2.s, e2 = r2.v, u2 = r2.a;
  t2 = t2 / 360 * 6, n2 /= 100, e2 /= 100;
  var a2 = Math.floor(t2), o2 = e2 * (1 - n2), i2 = e2 * (1 - (t2 - a2) * n2), s2 = e2 * (1 - (1 - t2 + a2) * n2), h2 = a2 % 6;
  return { r: 255 * [e2, i2, o2, o2, s2, e2][h2], g: 255 * [s2, e2, e2, i2, o2, o2][h2], b: 255 * [o2, o2, s2, e2, e2, i2][h2], a: u2 };
}, g = function(r2) {
  return { h: u$2(r2.h), s: e$2(r2.s, 0, 100), l: e$2(r2.l, 0, 100), a: e$2(r2.a) };
}, d$1 = function(r2) {
  return { h: n$2(r2.h), s: n$2(r2.s), l: n$2(r2.l), a: n$2(r2.a, 3) };
}, f$1 = function(r2) {
  return b$2((n2 = (t2 = r2).s, { h: t2.h, s: (n2 *= ((e2 = t2.l) < 50 ? e2 : 100 - e2) / 100) > 0 ? 2 * n2 / (e2 + n2) * 100 : 0, v: e2 + n2, a: t2.a }));
  var t2, n2, e2;
}, c$1 = function(r2) {
  return { h: (t2 = h$2(r2)).h, s: (u2 = (200 - (n2 = t2.s)) * (e2 = t2.v) / 100) > 0 && u2 < 200 ? n2 * e2 / 100 / (u2 <= 100 ? u2 : 200 - u2) * 100 : 0, l: u2 / 2, a: t2.a };
  var t2, n2, e2, u2;
}, l$2 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, p$2 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, v$1 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, y$1 = { string: [[function(r2) {
  var t2 = i$2.exec(r2);
  return t2 ? (r2 = t2[1]).length <= 4 ? { r: parseInt(r2[0] + r2[0], 16), g: parseInt(r2[1] + r2[1], 16), b: parseInt(r2[2] + r2[2], 16), a: 4 === r2.length ? n$2(parseInt(r2[3] + r2[3], 16) / 255, 2) : 1 } : 6 === r2.length || 8 === r2.length ? { r: parseInt(r2.substr(0, 2), 16), g: parseInt(r2.substr(2, 2), 16), b: parseInt(r2.substr(4, 2), 16), a: 8 === r2.length ? n$2(parseInt(r2.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(r2) {
  var t2 = v$1.exec(r2) || m.exec(r2);
  return t2 ? t2[2] !== t2[4] || t2[4] !== t2[6] ? null : a$2({ r: Number(t2[1]) / (t2[2] ? 100 / 255 : 1), g: Number(t2[3]) / (t2[4] ? 100 / 255 : 1), b: Number(t2[5]) / (t2[6] ? 100 / 255 : 1), a: void 0 === t2[7] ? 1 : Number(t2[7]) / (t2[8] ? 100 : 1) }) : null;
}, "rgb"], [function(t2) {
  var n2 = l$2.exec(t2) || p$2.exec(t2);
  if (!n2) return null;
  var e2, u2, a2 = g({ h: (e2 = n2[1], u2 = n2[2], void 0 === u2 && (u2 = "deg"), Number(e2) * (r$2[u2] || 1)), s: Number(n2[3]), l: Number(n2[4]), a: void 0 === n2[5] ? 1 : Number(n2[5]) / (n2[6] ? 100 : 1) });
  return f$1(a2);
}, "hsl"]], object: [[function(r2) {
  var n2 = r2.r, e2 = r2.g, u2 = r2.b, o2 = r2.a, i2 = void 0 === o2 ? 1 : o2;
  return t$3(n2) && t$3(e2) && t$3(u2) ? a$2({ r: Number(n2), g: Number(e2), b: Number(u2), a: Number(i2) }) : null;
}, "rgb"], [function(r2) {
  var n2 = r2.h, e2 = r2.s, u2 = r2.l, a2 = r2.a, o2 = void 0 === a2 ? 1 : a2;
  if (!t$3(n2) || !t$3(e2) || !t$3(u2)) return null;
  var i2 = g({ h: Number(n2), s: Number(e2), l: Number(u2), a: Number(o2) });
  return f$1(i2);
}, "hsl"], [function(r2) {
  var n2 = r2.h, a2 = r2.s, o2 = r2.v, i2 = r2.a, s2 = void 0 === i2 ? 1 : i2;
  if (!t$3(n2) || !t$3(a2) || !t$3(o2)) return null;
  var h2 = (function(r3) {
    return { h: u$2(r3.h), s: e$2(r3.s, 0, 100), v: e$2(r3.v, 0, 100), a: e$2(r3.a) };
  })({ h: Number(n2), s: Number(a2), v: Number(o2), a: Number(s2) });
  return b$2(h2);
}, "hsv"]] }, N = function(r2, t2) {
  for (var n2 = 0; n2 < t2.length; n2++) {
    var e2 = t2[n2][0](r2);
    if (e2) return [e2, t2[n2][1]];
  }
  return [null, void 0];
}, x$1 = function(r2) {
  return "string" == typeof r2 ? N(r2.trim(), y$1.string) : "object" == typeof r2 && null !== r2 ? N(r2, y$1.object) : [null, void 0];
}, M$2 = function(r2, t2) {
  var n2 = c$1(r2);
  return { h: n2.h, s: e$2(n2.s + 100 * t2, 0, 100), l: n2.l, a: n2.a };
}, H = function(r2) {
  return (299 * r2.r + 587 * r2.g + 114 * r2.b) / 1e3 / 255;
}, $ = function(r2, t2) {
  var n2 = c$1(r2);
  return { h: n2.h, s: n2.s, l: e$2(n2.l + 100 * t2, 0, 100), a: n2.a };
}, j = (function() {
  function r2(r3) {
    this.parsed = x$1(r3)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return r2.prototype.isValid = function() {
    return null !== this.parsed;
  }, r2.prototype.brightness = function() {
    return n$2(H(this.rgba), 2);
  }, r2.prototype.isDark = function() {
    return H(this.rgba) < 0.5;
  }, r2.prototype.isLight = function() {
    return H(this.rgba) >= 0.5;
  }, r2.prototype.toHex = function() {
    return r3 = o$3(this.rgba), t2 = r3.r, e2 = r3.g, u2 = r3.b, i2 = (a2 = r3.a) < 1 ? s$1(n$2(255 * a2)) : "", "#" + s$1(t2) + s$1(e2) + s$1(u2) + i2;
    var r3, t2, e2, u2, a2, i2;
  }, r2.prototype.toRgb = function() {
    return o$3(this.rgba);
  }, r2.prototype.toRgbString = function() {
    return r3 = o$3(this.rgba), t2 = r3.r, n2 = r3.g, e2 = r3.b, (u2 = r3.a) < 1 ? "rgba(" + t2 + ", " + n2 + ", " + e2 + ", " + u2 + ")" : "rgb(" + t2 + ", " + n2 + ", " + e2 + ")";
    var r3, t2, n2, e2, u2;
  }, r2.prototype.toHsl = function() {
    return d$1(c$1(this.rgba));
  }, r2.prototype.toHslString = function() {
    return r3 = d$1(c$1(this.rgba)), t2 = r3.h, n2 = r3.s, e2 = r3.l, (u2 = r3.a) < 1 ? "hsla(" + t2 + ", " + n2 + "%, " + e2 + "%, " + u2 + ")" : "hsl(" + t2 + ", " + n2 + "%, " + e2 + "%)";
    var r3, t2, n2, e2, u2;
  }, r2.prototype.toHsv = function() {
    return r3 = h$2(this.rgba), { h: n$2(r3.h), s: n$2(r3.s), v: n$2(r3.v), a: n$2(r3.a, 3) };
    var r3;
  }, r2.prototype.invert = function() {
    return w$1({ r: 255 - (r3 = this.rgba).r, g: 255 - r3.g, b: 255 - r3.b, a: r3.a });
    var r3;
  }, r2.prototype.saturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$1(M$2(this.rgba, r3));
  }, r2.prototype.desaturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$1(M$2(this.rgba, -r3));
  }, r2.prototype.grayscale = function() {
    return w$1(M$2(this.rgba, -1));
  }, r2.prototype.lighten = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$1($(this.rgba, r3));
  }, r2.prototype.darken = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$1($(this.rgba, -r3));
  }, r2.prototype.rotate = function(r3) {
    return void 0 === r3 && (r3 = 15), this.hue(this.hue() + r3);
  }, r2.prototype.alpha = function(r3) {
    return "number" == typeof r3 ? w$1({ r: (t2 = this.rgba).r, g: t2.g, b: t2.b, a: r3 }) : n$2(this.rgba.a, 3);
    var t2;
  }, r2.prototype.hue = function(r3) {
    var t2 = c$1(this.rgba);
    return "number" == typeof r3 ? w$1({ h: r3, s: t2.s, l: t2.l, a: t2.a }) : n$2(t2.h);
  }, r2.prototype.isEqual = function(r3) {
    return this.toHex() === w$1(r3).toHex();
  }, r2;
})(), w$1 = function(r2) {
  return r2 instanceof j ? r2 : new j(r2);
}, S = [], k = function(r2) {
  r2.forEach(function(r3) {
    S.indexOf(r3) < 0 && (r3(j, y$1), S.push(r3));
  });
};
var a$1 = function(a2) {
  return "string" == typeof a2 ? a2.length > 0 : "number" == typeof a2;
}, t$2 = function(a2, t2, o2) {
  return void 0 === t2 && (t2 = 0), void 0 === o2 && (o2 = Math.pow(10, t2)), Math.round(o2 * a2) / o2 + 0;
}, o$2 = function(a2, t2, o2) {
  return void 0 === t2 && (t2 = 0), void 0 === o2 && (o2 = 1), a2 > o2 ? o2 : a2 > t2 ? a2 : t2;
}, r$1 = function(a2) {
  var t2 = a2 / 255;
  return t2 < 0.04045 ? t2 / 12.92 : Math.pow((t2 + 0.055) / 1.055, 2.4);
}, h$1 = function(a2) {
  return 255 * (a2 > 31308e-7 ? 1.055 * Math.pow(a2, 1 / 2.4) - 0.055 : 12.92 * a2);
}, n$1 = 96.422, p$1 = 100, M$1 = 82.521, u$1 = function(a2) {
  var t2, r2, n2 = { x: 0.9555766 * (t2 = a2).x + -0.0230393 * t2.y + 0.0631636 * t2.z, y: -0.0282895 * t2.x + 1.0099416 * t2.y + 0.0210077 * t2.z, z: 0.0122982 * t2.x + -0.020483 * t2.y + 1.3299098 * t2.z };
  return r2 = { r: h$1(0.032404542 * n2.x - 0.015371385 * n2.y - 4985314e-9 * n2.z), g: h$1(-969266e-8 * n2.x + 0.018760108 * n2.y + 41556e-8 * n2.z), b: h$1(556434e-9 * n2.x - 2040259e-9 * n2.y + 0.010572252 * n2.z), a: a2.a }, { r: o$2(r2.r, 0, 255), g: o$2(r2.g, 0, 255), b: o$2(r2.b, 0, 255), a: o$2(r2.a) };
}, e$1 = function(a2) {
  var t2 = r$1(a2.r), h2 = r$1(a2.g), u2 = r$1(a2.b);
  return (function(a3) {
    return { x: o$2(a3.x, 0, n$1), y: o$2(a3.y, 0, p$1), z: o$2(a3.z, 0, M$1), a: o$2(a3.a) };
  })((function(a3) {
    return { x: 1.0478112 * a3.x + 0.0228866 * a3.y + -0.050127 * a3.z, y: 0.0295424 * a3.x + 0.9904844 * a3.y + -0.0170491 * a3.z, z: -92345e-7 * a3.x + 0.0150436 * a3.y + 0.7521316 * a3.z, a: a3.a };
  })({ x: 100 * (0.4124564 * t2 + 0.3575761 * h2 + 0.1804375 * u2), y: 100 * (0.2126729 * t2 + 0.7151522 * h2 + 0.072175 * u2), z: 100 * (0.0193339 * t2 + 0.119192 * h2 + 0.9503041 * u2), a: a2.a }));
}, w = 216 / 24389, b$1 = 24389 / 27, i$1 = function(t2) {
  var r2 = t2.l, h2 = t2.a, n2 = t2.b, p2 = t2.alpha, M2 = void 0 === p2 ? 1 : p2;
  if (!a$1(r2) || !a$1(h2) || !a$1(n2)) return null;
  var u2 = (function(a2) {
    return { l: o$2(a2.l, 0, 400), a: a2.a, b: a2.b, alpha: o$2(a2.alpha) };
  })({ l: Number(r2), a: Number(h2), b: Number(n2), alpha: Number(M2) });
  return l$1(u2);
}, l$1 = function(a2) {
  var t2 = (a2.l + 16) / 116, o2 = a2.a / 500 + t2, r2 = t2 - a2.b / 200;
  return u$1({ x: (Math.pow(o2, 3) > w ? Math.pow(o2, 3) : (116 * o2 - 16) / b$1) * n$1, y: (a2.l > 8 ? Math.pow((a2.l + 16) / 116, 3) : a2.l / b$1) * p$1, z: (Math.pow(r2, 3) > w ? Math.pow(r2, 3) : (116 * r2 - 16) / b$1) * M$1, a: a2.alpha });
};
function labPlugin(a2, r2) {
  a2.prototype.toLab = function() {
    return o2 = e$1(this.rgba), h2 = o2.y / p$1, u2 = o2.z / M$1, r3 = (r3 = o2.x / n$1) > w ? Math.cbrt(r3) : (b$1 * r3 + 16) / 116, a3 = { l: 116 * (h2 = h2 > w ? Math.cbrt(h2) : (b$1 * h2 + 16) / 116) - 16, a: 500 * (r3 - h2), b: 200 * (h2 - (u2 = u2 > w ? Math.cbrt(u2) : (b$1 * u2 + 16) / 116)), alpha: o2.a }, { l: t$2(a3.l, 2), a: t$2(a3.a, 2), b: t$2(a3.b, 2), alpha: t$2(a3.alpha, 3) };
    var a3, o2, r3, h2, u2;
  }, a2.prototype.delta = function(r3) {
    void 0 === r3 && (r3 = "#FFF");
    var h2 = r3 instanceof a2 ? r3 : new a2(r3), n2 = (function(a3, t2) {
      var o2 = a3.l, r4 = a3.a, h3 = a3.b, n3 = t2.l, p2 = t2.a, M2 = t2.b, u2 = 180 / Math.PI, e2 = Math.PI / 180, w2 = Math.pow(Math.pow(r4, 2) + Math.pow(h3, 2), 0.5), b2 = Math.pow(Math.pow(p2, 2) + Math.pow(M2, 2), 0.5), i2 = (o2 + n3) / 2, l2 = Math.pow((w2 + b2) / 2, 7), c2 = 0.5 * (1 - Math.pow(l2 / (l2 + Math.pow(25, 7)), 0.5)), f2 = r4 * (1 + c2), y2 = p2 * (1 + c2), v2 = Math.pow(Math.pow(f2, 2) + Math.pow(h3, 2), 0.5), x2 = Math.pow(Math.pow(y2, 2) + Math.pow(M2, 2), 0.5), z = (v2 + x2) / 2, s2 = 0 === f2 && 0 === h3 ? 0 : Math.atan2(h3, f2) * u2, d2 = 0 === y2 && 0 === M2 ? 0 : Math.atan2(M2, y2) * u2;
      s2 < 0 && (s2 += 360), d2 < 0 && (d2 += 360);
      var g2 = d2 - s2, m2 = Math.abs(d2 - s2);
      m2 > 180 && d2 <= s2 ? g2 += 360 : m2 > 180 && d2 > s2 && (g2 -= 360);
      var N2 = s2 + d2;
      m2 <= 180 ? N2 /= 2 : N2 = (s2 + d2 < 360 ? N2 + 360 : N2 - 360) / 2;
      var F = 1 - 0.17 * Math.cos(e2 * (N2 - 30)) + 0.24 * Math.cos(2 * e2 * N2) + 0.32 * Math.cos(e2 * (3 * N2 + 6)) - 0.2 * Math.cos(e2 * (4 * N2 - 63)), L = n3 - o2, I = x2 - v2, P = 2 * Math.sin(e2 * g2 / 2) * Math.pow(v2 * x2, 0.5), j2 = 1 + 0.015 * Math.pow(i2 - 50, 2) / Math.pow(20 + Math.pow(i2 - 50, 2), 0.5), k2 = 1 + 0.045 * z, q = 1 + 0.015 * z * F, A = 30 * Math.exp(-1 * Math.pow((N2 - 275) / 25, 2)), B = -2 * Math.pow(l2 / (l2 + Math.pow(25, 7)), 0.5) * Math.sin(2 * e2 * A);
      return Math.pow(Math.pow(L / 1 / j2, 2) + Math.pow(I / 1 / k2, 2) + Math.pow(P / 1 / q, 2) + B * I * P / (1 * k2 * 1 * q), 0.5);
    })(this.toLab(), h2.toLab()) / 100;
    return o$2(t$2(n2, 3));
  }, r2.object.push([i$1, "lab"]);
}
var r = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, t$1 = function(r2) {
  return "string" == typeof r2 ? r2.length > 0 : "number" == typeof r2;
}, a = function(r2, t2, a2) {
  return void 0 === t2 && (t2 = 0), void 0 === a2 && (a2 = Math.pow(10, t2)), Math.round(a2 * r2) / a2 + 0;
}, n = function(r2, t2, a2) {
  return void 0 === t2 && (t2 = 0), void 0 === a2 && (a2 = 1), r2 > a2 ? a2 : r2 > t2 ? r2 : t2;
}, u = function(r2) {
  var t2 = r2 / 255;
  return t2 < 0.04045 ? t2 / 12.92 : Math.pow((t2 + 0.055) / 1.055, 2.4);
}, h = function(r2) {
  return 255 * (r2 > 31308e-7 ? 1.055 * Math.pow(r2, 1 / 2.4) - 0.055 : 12.92 * r2);
}, o$1 = 96.422, e = 100, c = 82.521, i = function(r2) {
  var t2, a2, u2 = { x: 0.9555766 * (t2 = r2).x + -0.0230393 * t2.y + 0.0631636 * t2.z, y: -0.0282895 * t2.x + 1.0099416 * t2.y + 0.0210077 * t2.z, z: 0.0122982 * t2.x + -0.020483 * t2.y + 1.3299098 * t2.z };
  return a2 = { r: h(0.032404542 * u2.x - 0.015371385 * u2.y - 4985314e-9 * u2.z), g: h(-969266e-8 * u2.x + 0.018760108 * u2.y + 41556e-8 * u2.z), b: h(556434e-9 * u2.x - 2040259e-9 * u2.y + 0.010572252 * u2.z), a: r2.a }, { r: n(a2.r, 0, 255), g: n(a2.g, 0, 255), b: n(a2.b, 0, 255), a: n(a2.a) };
}, l = function(r2) {
  var t2 = u(r2.r), a2 = u(r2.g), h2 = u(r2.b);
  return (function(r3) {
    return { x: n(r3.x, 0, o$1), y: n(r3.y, 0, e), z: n(r3.z, 0, c), a: n(r3.a) };
  })((function(r3) {
    return { x: 1.0478112 * r3.x + 0.0228866 * r3.y + -0.050127 * r3.z, y: 0.0295424 * r3.x + 0.9904844 * r3.y + -0.0170491 * r3.z, z: -92345e-7 * r3.x + 0.0150436 * r3.y + 0.7521316 * r3.z, a: r3.a };
  })({ x: 100 * (0.4124564 * t2 + 0.3575761 * a2 + 0.1804375 * h2), y: 100 * (0.2126729 * t2 + 0.7151522 * a2 + 0.072175 * h2), z: 100 * (0.0193339 * t2 + 0.119192 * a2 + 0.9503041 * h2), a: r2.a }));
}, f = 216 / 24389, b = 24389 / 27, d = function(r2) {
  return { l: n(r2.l, 0, 100), c: r2.c, h: (t2 = r2.h, (t2 = isFinite(t2) ? t2 % 360 : 0) > 0 ? t2 : t2 + 360), a: r2.a };
  var t2;
}, p = function(r2) {
  return { l: a(r2.l, 2), c: a(r2.c, 2), h: a(r2.h, 2), a: a(r2.a, 3) };
}, v = function(r2) {
  var a2 = r2.l, n2 = r2.c, u2 = r2.h, h2 = r2.a, o2 = void 0 === h2 ? 1 : h2;
  if (!t$1(a2) || !t$1(n2) || !t$1(u2)) return null;
  var e2 = d({ l: Number(a2), c: Number(n2), h: Number(u2), a: Number(o2) });
  return M(e2);
}, y = function(r2) {
  var t2 = (function(r3) {
    var t3 = l(r3), a2 = t3.x / o$1, n3 = t3.y / e, u3 = t3.z / c;
    return a2 = a2 > f ? Math.cbrt(a2) : (b * a2 + 16) / 116, { l: 116 * (n3 = n3 > f ? Math.cbrt(n3) : (b * n3 + 16) / 116) - 16, a: 500 * (a2 - n3), b: 200 * (n3 - (u3 = u3 > f ? Math.cbrt(u3) : (b * u3 + 16) / 116)), alpha: t3.a };
  })(r2), n2 = a(t2.a, 3), u2 = a(t2.b, 3), h2 = Math.atan2(u2, n2) / Math.PI * 180;
  return { l: t2.l, c: Math.sqrt(n2 * n2 + u2 * u2), h: h2 < 0 ? h2 + 360 : h2, a: t2.alpha };
}, M = function(r2) {
  return t2 = { l: r2.l, a: r2.c * Math.cos(r2.h * Math.PI / 180), b: r2.c * Math.sin(r2.h * Math.PI / 180), alpha: r2.a }, n2 = t2.a / 500 + (a2 = (t2.l + 16) / 116), u2 = a2 - t2.b / 200, i({ x: (Math.pow(n2, 3) > f ? Math.pow(n2, 3) : (116 * n2 - 16) / b) * o$1, y: (t2.l > 8 ? Math.pow((t2.l + 16) / 116, 3) : t2.l / b) * e, z: (Math.pow(u2, 3) > f ? Math.pow(u2, 3) : (116 * u2 - 16) / b) * c, a: t2.alpha });
  var t2, a2, n2, u2;
}, x = /^lch\(\s*([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)\s+([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, s = function(t2) {
  var a2 = x.exec(t2);
  if (!a2) return null;
  var n2, u2, h2 = d({ l: Number(a2[1]), c: Number(a2[2]), h: (n2 = a2[3], u2 = a2[4], void 0 === u2 && (u2 = "deg"), Number(n2) * (r[u2] || 1)), a: void 0 === a2[5] ? 1 : Number(a2[5]) / (a2[6] ? 100 : 1) });
  return M(h2);
};
function lchPlugin(r2, t2) {
  r2.prototype.toLch = function() {
    return p(y(this.rgba));
  }, r2.prototype.toLchString = function() {
    return r3 = p(y(this.rgba)), t3 = r3.l, a2 = r3.c, n2 = r3.h, (u2 = r3.a) < 1 ? "lch(" + t3 + "% " + a2 + " " + n2 + " / " + u2 + ")" : "lch(" + t3 + "% " + a2 + " " + n2 + ")";
    var r3, t3, a2, n2, u2;
  }, t2.string.push([s, "lch"]), t2.object.push([v, "lch"]);
}
k([labPlugin, lchPlugin]);
const canonicalColorHexByKey = {
  black: "#000000",
  white: "#ffffff",
  gray: "#808080",
  red: "#ff0000",
  orange: "#ffa500",
  yellow: "#ffff00",
  green: "#008000",
  cyan: "#00ffff",
  blue: "#0000ff",
  purple: "#800080",
  pink: "#ffc0cb",
  brown: "#a52a2a"
};
const canonicalAnchorDefinitions = Object.fromEntries(
  Object.entries(canonicalColorHexByKey).map(([canonical, hex]) => [
    canonical,
    { hex, canonical }
  ])
);
const extraAnchorDefinitions = {
  silver: { hex: "#c0c0c0", canonical: "gray" },
  grayDark: { hex: "#4d4d4d", canonical: "gray" },
  grayCustom: { hex: "#757575", canonical: "gray" },
  grayLight: { hex: "#c8c8c8", canonical: "gray" },
  grayLighter: { hex: "#dcdcdc", canonical: "gray" },
  maroon: { hex: "#800000", canonical: "red" },
  redLight: { hex: "#f08080", canonical: "red" },
  redCustom: { hex: "#D4042D", canonical: "red" },
  redDark: { hex: "#8b0000", canonical: "red" },
  crimson: { hex: "#dc143c", canonical: "red" },
  wine: { hex: "#993355", canonical: "red" },
  orangeLight: { hex: "#ffa07a", canonical: "orange" },
  orangeCustom: { hex: "#F19143", canonical: "orange" },
  orangePresetAccessible: { hex: "#a6510c", canonical: "orange" },
  orangeDark: { hex: "#ff8c00", canonical: "orange" },
  yellowLight: { hex: "#ffffe0", canonical: "yellow" },
  yellowDark: { hex: "#bdb76b", canonical: "yellow" },
  yellowgreen: { hex: "#9acd32", canonical: "green" },
  olive: { hex: "#808000", canonical: "green" },
  lime: { hex: "#00ff00", canonical: "green" },
  greenLight: { hex: "#90ee90", canonical: "green" },
  greenCustom: { hex: "#2ca02c", canonical: "green" },
  greenDark: { hex: "#006400", canonical: "green" },
  teal: { hex: "#008080", canonical: "green" },
  aqua: { hex: "#00ffff", canonical: "cyan" },
  cyanLight: { hex: "#e0ffff", canonical: "cyan" },
  cyanMid: { hex: "#25b0c0", canonical: "cyan" },
  cyanDark: { hex: "#008b8b", canonical: "cyan" },
  navy: { hex: "#000080", canonical: "blue" },
  blueMid: { hex: "#4477aa", canonical: "blue" },
  blueSky: { hex: "#56b4e9", canonical: "blue" },
  blueCustom: { hex: "#648FFF", canonical: "blue" },
  bluePresetAccessible: { hex: "#1f5dff", canonical: "blue" },
  blueLight: { hex: "#add8e6", canonical: "blue" },
  blueDark: { hex: "#00008b", canonical: "blue" },
  fuchsia: { hex: "#ff00ff", canonical: "purple" },
  purpleCustom: { hex: "#644CD6", canonical: "purple" },
  purpleMuted: { hex: "#9c5686", canonical: "purple" },
  purpleLight: { hex: "#dda0dd", canonical: "purple" },
  purpleDark: { hex: "#8b008b", canonical: "purple" },
  hotpink: { hex: "#ff69b4", canonical: "pink" },
  pinkDark: { hex: "#ff1493", canonical: "pink" },
  brownLight: { hex: "#deb887", canonical: "brown" },
  brownDark: { hex: "#8b4513", canonical: "brown" }
};
const anchorDefinitions = {
  ...canonicalAnchorDefinitions,
  ...extraAnchorDefinitions
};
const anchorColordList = Object.values(anchorDefinitions).map((definition) => ({
  color: w$1(definition.hex),
  canonical: definition.canonical
}));
const NEUTRAL_CHROMA_THRESHOLD = 8;
const NEUTRAL_BLACK_MAX_LIGHTNESS = 14;
const NEUTRAL_WHITE_MIN_LIGHTNESS = 92;
function classifyNeutral(color) {
  const { c: c2, l: l2 } = color.toLch();
  if (c2 >= NEUTRAL_CHROMA_THRESHOLD) {
    return void 0;
  }
  if (l2 <= NEUTRAL_BLACK_MAX_LIGHTNESS) {
    return "black";
  }
  if (l2 >= NEUTRAL_WHITE_MIN_LIGHTNESS) {
    return "white";
  }
  return "gray";
}
function nearestCanonicalFamily(color) {
  let bestCanonical;
  let bestDelta = Infinity;
  for (const anchor of anchorColordList) {
    const delta = color.delta(anchor.color);
    if (delta < bestDelta) {
      bestDelta = delta;
      bestCanonical = anchor.canonical;
    }
  }
  return bestCanonical;
}
const cssNamedColorSet = /* @__PURE__ */ new Set([
  ...Object.keys(colorName),
  "transparent",
  "currentcolor"
]);
function isCssNamedColorKeyword(colorValue) {
  return cssNamedColorSet.has(colorValue.trim().toLowerCase());
}
function resolveColorWord(colorValue, options = {}) {
  const preserveCssNamedColor = options.preserveCssNamedColor ?? true;
  const invalidFallback = options.invalidFallback ?? "original";
  const trimmedColorValue = colorValue.trim();
  if (trimmedColorValue.length === 0) {
    return {
      englishWord: "",
      localizedWord: "",
      source: "invalid"
    };
  }
  if (preserveCssNamedColor && isCssNamedColorKeyword(trimmedColorValue)) {
    const lowerName = trimmedColorValue.toLowerCase();
    const key = `cssColor.${lowerName}`;
    const englishWord = trimmedColorValue;
    const localizedWord = options.translate ? options.translate(key, englishWord) : englishWord;
    return {
      key,
      englishWord,
      localizedWord,
      source: "named-css"
    };
  }
  try {
    const parsedColor = w$1(trimmedColorValue);
    if (!parsedColor.isValid()) {
      throw Error("Unparseable color value");
    }
    const canonicalName = classifyNeutral(parsedColor) ?? nearestCanonicalFamily(parsedColor);
    if (!canonicalName) {
      throw Error("No nearest canonical color resolved");
    }
    const key = `color.${canonicalName}`;
    const englishWord = canonicalName;
    const localizedWord = options.translate ? options.translate(key, englishWord) : englishWord;
    return {
      key,
      englishWord,
      localizedWord,
      source: "nearest-palette"
    };
  } catch (e2) {
    const englishWord = invalidFallback === "empty" ? "" : trimmedColorValue;
    return {
      englishWord,
      localizedWord: englishWord,
      source: "invalid"
    };
  }
}
function colorValueToWord(colorValue, options = {}) {
  return resolveColorWord(colorValue, options).localizedWord;
}
function bytesToHex(bytes) {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join(
    ""
  );
}
function hexToBytes(hex) {
  if (!/^[0-9a-f]+$/i.test(hex) || hex.length % 2 !== 0) {
    return null;
  }
  const bytes = new Uint8Array(hex.length / 2);
  for (let i2 = 0; i2 < hex.length; i2 += 2) {
    bytes[i2 / 2] = Number.parseInt(hex.slice(i2, i2 + 2), 16);
  }
  return bytes;
}
function encodeFillPatternColorToken(color) {
  return bytesToHex(new TextEncoder().encode(color.trim()));
}
function decodeFillPatternColorToken(token) {
  const bytes = hexToBytes(token);
  if (!bytes) {
    return null;
  }
  try {
    return new TextDecoder("utf-8", { fatal: true }).decode(bytes);
  } catch {
    return null;
  }
}
function isStyleValueWithPosition(value) {
  return typeof value === "object" && value !== null && "style" in value;
}
function getStyleValueString(styleDef, key) {
  const value = styleDef[key]?.style;
  return typeof value === "string" ? value : void 0;
}
function getStyleValueNumber(styleDef, key) {
  const value = styleDef[key]?.style;
  return typeof value === "number" ? value : void 0;
}
function setStyleValue(styleDef, key, style, position) {
  styleDef[key] = {
    style,
    position
  };
}
function normalizeStyleDefinitionValues(styleDef) {
  const normalizedStyleDefinition = {};
  for (const key in styleDef) {
    const typedKey = key;
    const value = styleDef[typedKey];
    if (value === void 0) {
      continue;
    }
    if (isStyleValueWithPosition(value)) {
      setStyleValue(
        normalizedStyleDefinition,
        typedKey,
        value.style,
        value.position
      );
    } else {
      setStyleValue(normalizedStyleDefinition, typedKey, value);
    }
  }
  return normalizedStyleDefinition;
}
function normalizeStyleDefinitionsValues(styleDefinitions) {
  const normalizedStyleDefinitions = {};
  for (const styleNumber in styleDefinitions) {
    normalizedStyleDefinitions[styleNumber] = normalizeStyleDefinitionValues(styleDefinitions[styleNumber]);
  }
  return normalizedStyleDefinitions;
}
function unwrapStyleDefinition(styleDef) {
  const unwrappedStyleDefinition = {};
  for (const key in styleDef) {
    const typedKey = key;
    const value = styleDef[typedKey]?.style;
    if (value !== void 0) {
      unwrappedStyleDefinition[typedKey] = value;
    }
  }
  return unwrappedStyleDefinition;
}
const DEFAULT_STYLE_VALUES = {
  lineOpacity: 0.7,
  lineWidth: 4,
  lineWidthWord: "thick",
  lineStyle: "solid",
  lineStyleWord: "",
  markerOpacity: 0.7,
  markerStyle: "circle",
  markerStyleWord: "point",
  markerSize: 5,
  markerFilled: true,
  fillOpacity: 0.3,
  fillPatternOpacity: 1,
  fillStyle: "solid",
  fillStyleWord: "",
  lineColor: "#1f5dff",
  lineColorDarkMode: "#648FFF",
  markerColor: "#1f5dff",
  markerColorDarkMode: "#648FFF",
  fillColor: "#1f5dff",
  fillColorDarkMode: "#648FFF",
  textColor: "black",
  textColorDarkMode: "white",
  highContrastColor: "#2963FF",
  highContrastColorDarkMode: "#92B4FF"
};
const RESOLVED_STYLE_FALLBACKS = {
  ...DEFAULT_STYLE_VALUES,
  lineColorWord: "",
  lineColorWordDarkMode: "",
  markerColorWord: "",
  markerColorWordDarkMode: "",
  fillColorWord: "",
  fillColorWordDarkMode: "",
  textColorWord: "",
  textColorWordDarkMode: "",
  highContrastColorWord: "",
  highContrastColorWordDarkMode: "",
  backgroundColor: "",
  backgroundColorWord: "",
  backgroundColorDarkMode: "",
  backgroundColorWordDarkMode: ""
};
function resolveStyleDefinition(styleDef) {
  const resolved = { ...RESOLVED_STYLE_FALLBACKS };
  const writable = resolved;
  for (const key of Object.keys(
    RESOLVED_STYLE_FALLBACKS
  )) {
    const value = styleDef[key];
    if (value !== void 0) {
      writable[key] = value;
    }
  }
  return resolved;
}
function positionSortValue(position) {
  if (typeof position.start?.offset === "number") {
    return position.start.offset;
  }
  const line = position.start?.line ?? 0;
  const column = position.start?.column ?? 0;
  return line * 1e6 + column;
}
function latestPosition(...positions) {
  let latest;
  for (const position of positions) {
    if (!position) {
      continue;
    }
    if (!latest || positionSortValue(position) >= positionSortValue(latest)) {
      latest = position;
    }
  }
  return latest;
}
const defaultPalette = {
  name: "default",
  description: "The standard Doenet styles: blue, red, orange, purple, black, and gray.",
  styles: {
    1: { ...DEFAULT_STYLE_VALUES },
    2: {
      lineColor: "#D4042D",
      lineColorDarkMode: "#F1466A",
      lineOpacity: 0.7,
      lineWidth: 2,
      lineWidthWord: "",
      lineStyle: "solid",
      lineStyleWord: "",
      markerColor: "#D4042D",
      markerColorDarkMode: "#F1466A",
      markerOpacity: 0.7,
      markerStyle: "square",
      markerStyleWord: "square",
      markerSize: 5,
      fillColor: "#D4042D",
      fillColorDarkMode: "#F1466A",
      fillOpacity: 0.3,
      textColor: "#D4042D",
      textColorDarkMode: "#FF7A7A",
      highContrastColor: "#D4042D",
      highContrastColorDarkMode: "#FF7A7A"
    },
    3: {
      lineColor: "#a6510c",
      lineColorDarkMode: "#F19143",
      lineOpacity: 0.7,
      lineWidth: 3,
      lineWidthWord: "",
      lineStyle: "solid",
      lineStyleWord: "",
      markerColor: "#a6510c",
      markerColorDarkMode: "#F19143",
      markerOpacity: 0.7,
      markerStyle: "triangle",
      markerStyleWord: "triangle",
      markerSize: 5,
      fillColor: "#a6510c",
      fillColorDarkMode: "#F19143",
      fillOpacity: 0.3,
      textColor: "#BE5A0E",
      textColorDarkMode: "#FFA94D",
      highContrastColor: "#BE5A0E",
      highContrastColorDarkMode: "#FFA94D"
    },
    4: {
      lineColor: "#644CD6",
      lineColorDarkMode: "#9F8FE8",
      lineColorWordDarkMode: "purple",
      lineOpacity: 0.7,
      lineWidth: 2,
      lineWidthWord: "",
      lineStyle: "solid",
      lineStyleWord: "",
      markerColor: "#644CD6",
      markerColorDarkMode: "#9F8FE8",
      markerColorWordDarkMode: "purple",
      markerOpacity: 0.7,
      markerStyle: "diamond",
      markerStyleWord: "diamond",
      markerSize: 5,
      fillColor: "#644CD6",
      fillColorDarkMode: "#9F8FE8",
      fillColorWordDarkMode: "purple",
      fillOpacity: 0.3,
      textColor: "#644CD6",
      textColorDarkMode: "#B0A4EE",
      highContrastColor: "#644CD6",
      highContrastColorDarkMode: "#B0A4EE"
    },
    5: {
      lineColor: "black",
      lineColorDarkMode: "white",
      lineOpacity: 1,
      lineWidth: 1,
      lineWidthWord: "thin",
      lineStyle: "solid",
      lineStyleWord: "",
      markerColor: "black",
      markerColorDarkMode: "white",
      markerOpacity: 1,
      markerStyle: "circle",
      markerStyleWord: "point",
      markerSize: 5,
      fillColor: "black",
      fillColorDarkMode: "white",
      fillOpacity: 0.7,
      textColor: "black",
      textColorDarkMode: "white",
      highContrastColor: "black",
      highContrastColorDarkMode: "white"
    },
    6: {
      lineColor: "#636363",
      lineColorDarkMode: "#CCCCCC",
      lineOpacity: 0.7,
      lineWidth: 1,
      lineWidthWord: "thin",
      lineStyle: "dotted",
      lineStyleWord: "dotted",
      markerColor: "#636363",
      markerColorDarkMode: "#CCCCCC",
      markerOpacity: 0.7,
      markerStyle: "circle",
      markerStyleWord: "point",
      markerSize: 5,
      fillColor: "#636363",
      fillColorDarkMode: "#CCCCCC",
      fillOpacity: 0.3,
      textColor: "#757575",
      textColorDarkMode: "#B0B0B0",
      highContrastColor: "#757575",
      highContrastColorDarkMode: "#B0B0B0"
    }
  }
};
const okabeItoPalette = {
  name: "okabeIto",
  description: "Colorblind-friendly blues, oranges, greens, and purples adapted from the Okabe-Ito palette, with varied marker shapes and line styles.",
  styles: {
    1: {
      // blue (canonical #0072b2)
      lineColor: "#0072b2",
      markerColor: "#0072b2",
      fillColor: "#0072b2",
      highContrastColor: "#0072b2",
      lineColorDarkMode: "#0072b2",
      markerColorDarkMode: "#0072b2",
      fillColorDarkMode: "#0072b2",
      lineWidth: 4,
      markerStyle: "circle"
    },
    2: {
      // vermillion (canonical #d55e00, darkened for text contrast)
      lineColor: "#c15400",
      markerColor: "#c15400",
      fillColor: "#c15400",
      textColor: "#c15400",
      highContrastColor: "#c15400",
      lineColorDarkMode: "#d55e00",
      markerColorDarkMode: "#d55e00",
      fillColorDarkMode: "#d55e00",
      textColorDarkMode: "#d55e00",
      lineWidth: 2,
      markerStyle: "square"
    },
    3: {
      // bluish green (canonical #009e73)
      lineColor: "#009e73",
      markerColor: "#009e73",
      fillColor: "#009e73",
      textColor: "#008561",
      highContrastColor: "#008561",
      lineColorDarkMode: "#009e73",
      markerColorDarkMode: "#009e73",
      fillColorDarkMode: "#009e73",
      textColorDarkMode: "#009e73",
      lineWidth: 3,
      markerStyle: "triangle"
    },
    4: {
      // reddish purple (canonical #cc79a7)
      lineColor: "#cc79a7",
      markerColor: "#cc79a7",
      fillColor: "#cc79a7",
      textColor: "#a35f85",
      highContrastColor: "#a35f85",
      lineColorWord: "purple",
      markerColorWord: "purple",
      fillColorWord: "purple",
      lineColorDarkMode: "#cc79a7",
      markerColorDarkMode: "#cc79a7",
      fillColorDarkMode: "#cc79a7",
      textColorDarkMode: "#cc79a7",
      lineColorWordDarkMode: "purple",
      markerColorWordDarkMode: "purple",
      fillColorWordDarkMode: "purple",
      textColorWordDarkMode: "purple",
      highContrastColorWordDarkMode: "purple",
      lineWidth: 2,
      markerStyle: "diamond"
    },
    5: {
      // black (canonical #000000; inverted to white in dark mode)
      lineColor: "#000000",
      markerColor: "#000000",
      fillColor: "#000000",
      textColor: "#000000",
      highContrastColor: "#000000",
      lineColorDarkMode: "#ffffff",
      markerColorDarkMode: "#ffffff",
      fillColorDarkMode: "#ffffff",
      textColorDarkMode: "#ffffff",
      lineWidth: 2,
      markerStyle: "triangleDown"
    },
    6: {
      // yellow (canonical #f0e442, darkened to olive in light mode)
      lineColor: "#5a5513",
      markerColor: "#5a5513",
      fillColor: "#5a5513",
      textColor: "#5a5513",
      highContrastColor: "#5a5513",
      lineColorWord: "olive",
      markerColorWord: "olive",
      fillColorWord: "olive",
      textColorWord: "olive",
      highContrastColorWord: "olive",
      lineColorDarkMode: "#f0e442",
      markerColorDarkMode: "#f0e442",
      fillColorDarkMode: "#f0e442",
      textColorDarkMode: "#f0e442",
      lineWidth: 2,
      markerStyle: "triangleLeft"
    },
    7: {
      // sky blue (canonical #56b4e9, darkened for light mode)
      lineColor: "#499bca",
      markerColor: "#499bca",
      fillColor: "#499bca",
      textColor: "#397ba1",
      highContrastColor: "#397ba1",
      lineColorWord: "skyblue",
      markerColorWord: "skyblue",
      fillColorWord: "skyblue",
      textColorWord: "skyblue",
      highContrastColorWord: "skyblue",
      lineColorDarkMode: "#56b4e9",
      markerColorDarkMode: "#56b4e9",
      fillColorDarkMode: "#56b4e9",
      textColorDarkMode: "#56b4e9",
      lineColorWordDarkMode: "skyblue",
      markerColorWordDarkMode: "skyblue",
      fillColorWordDarkMode: "skyblue",
      textColorWordDarkMode: "skyblue",
      highContrastColorWordDarkMode: "skyblue",
      lineWidth: 3,
      lineStyle: "dashed",
      markerStyle: "triangleRight"
    },
    8: {
      // orange (canonical #e69f00, darkened for light mode)
      lineColor: "#c58700",
      markerColor: "#c58700",
      fillColor: "#c58700",
      textColor: "#9d6b00",
      highContrastColor: "#9d6b00",
      lineColorWord: "goldenrod",
      markerColorWord: "goldenrod",
      fillColorWord: "goldenrod",
      textColorWord: "goldenrod",
      highContrastColorWord: "goldenrod",
      lineColorDarkMode: "#e69f00",
      markerColorDarkMode: "#e69f00",
      fillColorDarkMode: "#e69f00",
      textColorDarkMode: "#e69f00",
      lineColorWordDarkMode: "goldenrod",
      markerColorWordDarkMode: "goldenrod",
      fillColorWordDarkMode: "goldenrod",
      textColorWordDarkMode: "goldenrod",
      highContrastColorWordDarkMode: "goldenrod",
      lineWidth: 1,
      lineStyle: "dotted",
      markerStyle: "circle"
    }
  }
};
const tolBrightPalette = {
  name: "tolBright",
  description: "Colorblind-friendly bright blues, reds, greens, and purples from Paul Tol's bright palette, with varied marker shapes and line styles.",
  styles: {
    1: {
      lineColor: "#4477aa",
      markerColor: "#4477aa",
      fillColor: "#4477aa",
      highContrastColor: "#4477aa",
      lineColorDarkMode: "#4477aa",
      markerColorDarkMode: "#4477aa",
      fillColorDarkMode: "#4477aa",
      lineWidth: 4,
      markerStyle: "circle"
    },
    2: {
      lineColor: "#ee6677",
      markerColor: "#ee6677",
      fillColor: "#ee6677",
      textColor: "#bf515e",
      highContrastColor: "#bf515e",
      lineColorDarkMode: "#ee6677",
      markerColorDarkMode: "#ee6677",
      fillColorDarkMode: "#ee6677",
      textColorDarkMode: "#ee6677",
      lineWidth: 2,
      markerStyle: "square"
    },
    3: {
      lineColor: "#228833",
      markerColor: "#228833",
      fillColor: "#228833",
      textColor: "#228833",
      highContrastColor: "#228833",
      lineColorDarkMode: "#228833",
      markerColorDarkMode: "#228833",
      fillColorDarkMode: "#228833",
      textColorDarkMode: "#3d8e47",
      lineWidth: 3,
      markerStyle: "triangle"
    },
    4: {
      lineColor: "#a29534",
      markerColor: "#a29534",
      fillColor: "#a29534",
      textColor: "#817628",
      highContrastColor: "#817628",
      lineColorWord: "olive",
      markerColorWord: "olive",
      fillColorWord: "olive",
      textColorWord: "olive",
      highContrastColorWord: "olive",
      lineColorDarkMode: "#ccbb44",
      markerColorDarkMode: "#ccbb44",
      fillColorDarkMode: "#ccbb44",
      textColorDarkMode: "#ccbb44",
      lineWidth: 2,
      markerStyle: "diamond"
    },
    5: {
      lineColor: "#4d9db8",
      markerColor: "#4d9db8",
      fillColor: "#4d9db8",
      textColor: "#3c7d94",
      highContrastColor: "#3c7d94",
      textColorWord: "cyan",
      highContrastColorWord: "cyan",
      lineColorDarkMode: "#66ccee",
      markerColorDarkMode: "#66ccee",
      fillColorDarkMode: "#66ccee",
      textColorDarkMode: "#66ccee",
      lineColorWordDarkMode: "cyan",
      markerColorWordDarkMode: "cyan",
      fillColorWordDarkMode: "cyan",
      textColorWordDarkMode: "cyan",
      highContrastColorWordDarkMode: "cyan",
      lineWidth: 2,
      markerStyle: "triangleDown"
    },
    6: {
      lineColor: "#aa3377",
      markerColor: "#aa3377",
      fillColor: "#aa3377",
      textColor: "#aa3377",
      highContrastColor: "#aa3377",
      lineColorDarkMode: "#aa3377",
      markerColorDarkMode: "#aa3377",
      fillColorDarkMode: "#aa3377",
      textColorDarkMode: "#b5648c",
      lineWidth: 2,
      markerStyle: "triangleLeft"
    },
    7: {
      lineColor: "#939393",
      markerColor: "#939393",
      fillColor: "#939393",
      textColor: "#757575",
      highContrastColor: "#757575",
      lineColorDarkMode: "#bbbbbb",
      markerColorDarkMode: "#bbbbbb",
      fillColorDarkMode: "#bbbbbb",
      textColorDarkMode: "#bbbbbb",
      lineWidth: 3,
      lineStyle: "dashed",
      markerStyle: "triangleRight"
    }
  }
};
const tolMutedPalette = {
  name: "tolMuted",
  description: "Nine colorblind-friendly muted styles from Paul Tol's muted palette, with varied marker shapes and line styles.",
  styles: {
    1: {
      lineColor: "#332288",
      markerColor: "#332288",
      fillColor: "#332288",
      highContrastColor: "#332288",
      lineColorWord: "indigo",
      markerColorWord: "indigo",
      fillColorWord: "indigo",
      highContrastColorWord: "indigo",
      lineColorDarkMode: "#8a86e8",
      markerColorDarkMode: "#8a86e8",
      fillColorDarkMode: "#8a86e8",
      lineColorWordDarkMode: "indigo",
      markerColorWordDarkMode: "indigo",
      fillColorWordDarkMode: "indigo",
      highContrastColorWordDarkMode: "indigo",
      lineWidth: 4,
      markerStyle: "circle"
    },
    2: {
      lineColor: "#669ab5",
      markerColor: "#669ab5",
      fillColor: "#669ab5",
      textColor: "#507a90",
      highContrastColor: "#507a90",
      lineColorDarkMode: "#88ccee",
      markerColorDarkMode: "#88ccee",
      fillColorDarkMode: "#88ccee",
      textColorDarkMode: "#88ccee",
      lineWidth: 2,
      markerStyle: "square"
    },
    3: {
      lineColor: "#41a393",
      markerColor: "#41a393",
      fillColor: "#41a393",
      textColor: "#328175",
      highContrastColor: "#328175",
      lineColorWord: "teal",
      markerColorWord: "teal",
      fillColorWord: "teal",
      textColorWord: "teal",
      highContrastColorWord: "teal",
      lineColorDarkMode: "#44aa99",
      markerColorDarkMode: "#44aa99",
      fillColorDarkMode: "#44aa99",
      textColorDarkMode: "#44aa99",
      lineColorWordDarkMode: "teal",
      markerColorWordDarkMode: "teal",
      fillColorWordDarkMode: "teal",
      textColorWordDarkMode: "teal",
      highContrastColorWordDarkMode: "teal",
      lineWidth: 3,
      markerStyle: "triangle"
    },
    4: {
      lineColor: "#117733",
      markerColor: "#117733",
      fillColor: "#117733",
      textColor: "#117733",
      highContrastColor: "#117733",
      lineColorDarkMode: "#117733",
      markerColorDarkMode: "#117733",
      fillColorDarkMode: "#117733",
      textColorDarkMode: "#548a5f",
      lineWidth: 2,
      markerStyle: "diamond"
    },
    5: {
      lineColor: "#989833",
      markerColor: "#989833",
      fillColor: "#989833",
      textColor: "#787827",
      highContrastColor: "#787827",
      lineColorWord: "olive",
      markerColorWord: "olive",
      fillColorWord: "olive",
      textColorWord: "olive",
      highContrastColorWord: "olive",
      lineColorDarkMode: "#999933",
      markerColorDarkMode: "#999933",
      fillColorDarkMode: "#999933",
      textColorDarkMode: "#999933",
      lineColorWordDarkMode: "olive",
      markerColorWordDarkMode: "olive",
      fillColorWordDarkMode: "olive",
      textColorWordDarkMode: "olive",
      highContrastColorWordDarkMode: "olive",
      lineWidth: 2,
      markerStyle: "triangleDown"
    },
    6: {
      lineColor: "#867c46",
      markerColor: "#867c46",
      fillColor: "#867c46",
      textColor: "#7f7542",
      highContrastColor: "#7f7542",
      lineColorWord: "tan",
      markerColorWord: "tan",
      fillColorWord: "tan",
      textColorWord: "tan",
      highContrastColorWord: "tan",
      lineColorDarkMode: "#ddcc77",
      markerColorDarkMode: "#ddcc77",
      fillColorDarkMode: "#ddcc77",
      textColorDarkMode: "#ddcc77",
      lineColorWordDarkMode: "tan",
      markerColorWordDarkMode: "tan",
      fillColorWordDarkMode: "tan",
      textColorWordDarkMode: "tan",
      highContrastColorWordDarkMode: "tan",
      lineWidth: 2,
      markerStyle: "triangleLeft"
    },
    7: {
      lineColor: "#cc6677",
      markerColor: "#cc6677",
      fillColor: "#cc6677",
      textColor: "#b35968",
      highContrastColor: "#b35968",
      lineColorWord: "pink",
      markerColorWord: "pink",
      fillColorWord: "pink",
      textColorWord: "pink",
      highContrastColorWord: "pink",
      lineColorDarkMode: "#cc6677",
      markerColorDarkMode: "#cc6677",
      fillColorDarkMode: "#cc6677",
      textColorDarkMode: "#cc6677",
      lineColorWordDarkMode: "pink",
      markerColorWordDarkMode: "pink",
      fillColorWordDarkMode: "pink",
      textColorWordDarkMode: "pink",
      highContrastColorWordDarkMode: "pink",
      lineWidth: 3,
      lineStyle: "dashed",
      markerStyle: "triangleRight"
    },
    8: {
      lineColor: "#882255",
      markerColor: "#882255",
      fillColor: "#882255",
      textColor: "#882255",
      highContrastColor: "#882255",
      lineColorWord: "maroon",
      markerColorWord: "maroon",
      fillColorWord: "maroon",
      textColorWord: "maroon",
      highContrastColorWord: "maroon",
      lineColorDarkMode: "#924b69",
      markerColorDarkMode: "#924b69",
      fillColorDarkMode: "#924b69",
      textColorDarkMode: "#a17083",
      lineColorWordDarkMode: "maroon",
      markerColorWordDarkMode: "maroon",
      fillColorWordDarkMode: "maroon",
      textColorWordDarkMode: "maroon",
      highContrastColorWordDarkMode: "maroon",
      lineWidth: 1,
      lineStyle: "dotted",
      markerStyle: "circle"
    },
    9: {
      lineColor: "#aa4499",
      markerColor: "#aa4499",
      fillColor: "#aa4499",
      textColor: "#aa4499",
      highContrastColor: "#aa4499",
      lineColorDarkMode: "#aa4499",
      markerColorDarkMode: "#aa4499",
      fillColorDarkMode: "#aa4499",
      textColorDarkMode: "#b262a3",
      lineWidth: 2,
      lineStyle: "dashed",
      markerStyle: "square"
    }
  }
};
const tolHighContrastPalette = {
  name: "tolHighContrast",
  description: "Four maximum-distinction styles from Paul Tol's high-contrast palette, distinguishable even in grayscale.",
  styles: {
    1: {
      lineColor: "#004488",
      markerColor: "#004488",
      fillColor: "#004488",
      highContrastColor: "#004488",
      lineColorDarkMode: "#496194",
      markerColorDarkMode: "#496194",
      fillColorDarkMode: "#496194",
      lineWidth: 4,
      markerStyle: "circle"
    },
    2: {
      lineColor: "#b88d29",
      markerColor: "#b88d29",
      fillColor: "#b88d29",
      textColor: "#92701f",
      highContrastColor: "#92701f",
      lineColorWord: "gold",
      markerColorWord: "gold",
      fillColorWord: "gold",
      textColorWord: "gold",
      highContrastColorWord: "gold",
      lineColorDarkMode: "#ddaa33",
      markerColorDarkMode: "#ddaa33",
      fillColorDarkMode: "#ddaa33",
      textColorDarkMode: "#ddaa33",
      lineColorWordDarkMode: "gold",
      markerColorWordDarkMode: "gold",
      fillColorWordDarkMode: "gold",
      textColorWordDarkMode: "gold",
      highContrastColorWordDarkMode: "gold",
      lineWidth: 2,
      markerStyle: "square"
    },
    3: {
      lineColor: "#bb5566",
      markerColor: "#bb5566",
      fillColor: "#bb5566",
      textColor: "#bb5566",
      highContrastColor: "#bb5566",
      lineColorDarkMode: "#c06976",
      markerColorDarkMode: "#c06976",
      fillColorDarkMode: "#c06976",
      textColorDarkMode: "#c06976",
      lineWidth: 3,
      markerStyle: "triangle"
    },
    4: {
      lineColor: "#000000",
      markerColor: "#000000",
      fillColor: "#000000",
      textColor: "#000000",
      highContrastColor: "#000000",
      lineColorDarkMode: "#ffffff",
      markerColorDarkMode: "#ffffff",
      fillColorDarkMode: "#ffffff",
      textColorDarkMode: "#ffffff",
      lineWidth: 2,
      markerStyle: "diamond"
    }
  }
};
const ibmPalette = {
  name: "ibm",
  description: "Five colorblind-friendly styles from the IBM Design Library accessible palette, with varied marker shapes.",
  styles: {
    1: {
      lineColor: "#648fff",
      markerColor: "#648fff",
      fillColor: "#648fff",
      highContrastColor: "#4f71cb",
      lineColorDarkMode: "#648fff",
      markerColorDarkMode: "#648fff",
      fillColorDarkMode: "#648fff",
      lineWidth: 4,
      markerStyle: "circle"
    },
    2: {
      lineColor: "#6a53d5",
      markerColor: "#6a53d5",
      fillColor: "#6a53d5",
      textColor: "#6a53d5",
      highContrastColor: "#6a53d5",
      lineColorDarkMode: "#785ef0",
      markerColorDarkMode: "#785ef0",
      fillColorDarkMode: "#785ef0",
      textColorDarkMode: "#7f69f0",
      lineWidth: 2,
      markerStyle: "square"
    },
    3: {
      lineColor: "#dc267f",
      markerColor: "#dc267f",
      fillColor: "#dc267f",
      textColor: "#dc267f",
      highContrastColor: "#dc267f",
      lineColorWord: "magenta",
      markerColorWord: "magenta",
      fillColorWord: "magenta",
      textColorWord: "magenta",
      highContrastColorWord: "magenta",
      lineColorDarkMode: "#dc267f",
      markerColorDarkMode: "#dc267f",
      fillColorDarkMode: "#dc267f",
      textColorDarkMode: "#dd4186",
      lineColorWordDarkMode: "magenta",
      markerColorWordDarkMode: "magenta",
      fillColorWordDarkMode: "magenta",
      textColorWordDarkMode: "magenta",
      highContrastColorWordDarkMode: "magenta",
      lineWidth: 3,
      markerStyle: "triangle"
    },
    4: {
      lineColor: "#fe6100",
      markerColor: "#fe6100",
      fillColor: "#fe6100",
      textColor: "#cb4b00",
      highContrastColor: "#cb4b00",
      lineColorDarkMode: "#fe6100",
      markerColorDarkMode: "#fe6100",
      fillColorDarkMode: "#fe6100",
      textColorDarkMode: "#fe6100",
      lineWidth: 2,
      markerStyle: "diamond"
    },
    5: {
      lineColor: "#865a00",
      markerColor: "#865a00",
      fillColor: "#865a00",
      textColor: "#865a00",
      highContrastColor: "#865a00",
      lineColorWord: "gold",
      markerColorWord: "gold",
      fillColorWord: "gold",
      textColorWord: "gold",
      highContrastColorWord: "gold",
      lineColorDarkMode: "#ffb000",
      markerColorDarkMode: "#ffb000",
      fillColorDarkMode: "#ffb000",
      textColorDarkMode: "#ffb000",
      lineColorWordDarkMode: "gold",
      markerColorWordDarkMode: "gold",
      fillColorWordDarkMode: "gold",
      textColorWordDarkMode: "gold",
      highContrastColorWordDarkMode: "gold",
      lineWidth: 2,
      markerStyle: "triangleDown"
    }
  }
};
const grayscalePalette = {
  name: "grayscale",
  description: "Four grays with maximum luminance separation, for readers who distinguish styles by lightness alone.",
  styles: {
    1: {
      lineColor: "#000000",
      markerColor: "#000000",
      fillColor: "#000000",
      highContrastColor: "#000000",
      lineColorDarkMode: "#ffffff",
      markerColorDarkMode: "#ffffff",
      fillColorDarkMode: "#ffffff",
      highContrastColorDarkMode: "#ffffff",
      lineWidth: 4,
      markerStyle: "circle"
    },
    2: {
      lineColor: "#323232",
      markerColor: "#323232",
      fillColor: "#323232",
      textColor: "#323232",
      highContrastColor: "#323232",
      lineColorWord: "dark gray",
      markerColorWord: "dark gray",
      fillColorWord: "dark gray",
      textColorWord: "dark gray",
      highContrastColorWord: "dark gray",
      lineColorDarkMode: "#c7c7c7",
      markerColorDarkMode: "#c7c7c7",
      fillColorDarkMode: "#c7c7c7",
      textColorDarkMode: "#c7c7c7",
      highContrastColorDarkMode: "#c7c7c7",
      lineColorWordDarkMode: "light gray",
      markerColorWordDarkMode: "light gray",
      fillColorWordDarkMode: "light gray",
      textColorWordDarkMode: "light gray",
      highContrastColorWordDarkMode: "light gray",
      lineWidth: 2,
      markerStyle: "square"
    },
    3: {
      lineColor: "#616161",
      markerColor: "#616161",
      fillColor: "#616161",
      textColor: "#616161",
      highContrastColor: "#616161",
      lineColorDarkMode: "#929292",
      markerColorDarkMode: "#929292",
      fillColorDarkMode: "#929292",
      textColorDarkMode: "#929292",
      highContrastColorDarkMode: "#929292",
      lineWidth: 3,
      markerStyle: "triangle"
    },
    4: {
      lineColor: "#939393",
      markerColor: "#939393",
      fillColor: "#939393",
      textColor: "#767676",
      highContrastColor: "#767676",
      lineColorWord: "light gray",
      markerColorWord: "light gray",
      fillColorWord: "light gray",
      textColorWord: "light gray",
      highContrastColorWord: "light gray",
      lineColorDarkMode: "#626262",
      markerColorDarkMode: "#626262",
      fillColorDarkMode: "#626262",
      textColorDarkMode: "#7d7d7d",
      highContrastColorDarkMode: "#7d7d7d",
      lineColorWordDarkMode: "dark gray",
      markerColorWordDarkMode: "dark gray",
      fillColorWordDarkMode: "dark gray",
      textColorWordDarkMode: "dark gray",
      highContrastColorWordDarkMode: "dark gray",
      lineWidth: 2,
      markerStyle: "diamond"
    }
  }
};
const categoricalPalette = {
  name: "categorical",
  description: "Ten maximally varied hues adapted from the Category10 sequence, for documents needing many obviously distinct styles.",
  styles: {
    1: {
      lineColor: "#1f77b4",
      markerColor: "#1f77b4",
      fillColor: "#1f77b4",
      highContrastColor: "#1f77b4",
      lineColorDarkMode: "#5ba3dd",
      markerColorDarkMode: "#5ba3dd",
      fillColorDarkMode: "#5ba3dd",
      lineWidth: 4,
      markerStyle: "circle"
    },
    2: {
      lineColor: "#e7730c",
      markerColor: "#e7730c",
      fillColor: "#e7730c",
      textColor: "#b95b07",
      highContrastColor: "#b95b07",
      lineColorDarkMode: "#ff9d3c",
      markerColorDarkMode: "#ff9d3c",
      fillColorDarkMode: "#ff9d3c",
      textColorDarkMode: "#ff9d3c",
      lineWidth: 2,
      markerStyle: "square"
    },
    3: {
      lineColor: "#217a21",
      markerColor: "#217a21",
      fillColor: "#217a21",
      textColor: "#217a21",
      highContrastColor: "#217a21",
      lineColorDarkMode: "#2ca02c",
      markerColorDarkMode: "#2ca02c",
      fillColorDarkMode: "#2ca02c",
      textColorDarkMode: "#2ca02c",
      lineWidth: 3,
      markerStyle: "triangle"
    },
    4: {
      lineColor: "#d62728",
      markerColor: "#d62728",
      fillColor: "#d62728",
      textColor: "#d62728",
      highContrastColor: "#d62728",
      lineColorDarkMode: "#e2494a",
      markerColorDarkMode: "#e2494a",
      fillColorDarkMode: "#e2494a",
      textColorDarkMode: "#e2494a",
      lineWidth: 2,
      markerStyle: "diamond"
    },
    5: {
      lineColor: "#9467bd",
      markerColor: "#9467bd",
      fillColor: "#9467bd",
      textColor: "#8e62b5",
      highContrastColor: "#8e62b5",
      lineColorDarkMode: "#b48fd6",
      markerColorDarkMode: "#b48fd6",
      fillColorDarkMode: "#b48fd6",
      textColorDarkMode: "#b48fd6",
      lineWidth: 2,
      markerStyle: "triangleDown"
    },
    6: {
      lineColor: "#7a4a41",
      markerColor: "#7a4a41",
      fillColor: "#7a4a41",
      textColor: "#7a4a41",
      highContrastColor: "#7a4a41",
      lineColorDarkMode: "#a9705f",
      markerColorDarkMode: "#a9705f",
      fillColorDarkMode: "#a9705f",
      textColorDarkMode: "#a9705f",
      lineColorWordDarkMode: "brown",
      markerColorWordDarkMode: "brown",
      fillColorWordDarkMode: "brown",
      textColorWordDarkMode: "brown",
      highContrastColorWordDarkMode: "brown",
      lineWidth: 2,
      markerStyle: "triangleLeft"
    },
    7: {
      lineColor: "#d670b7",
      markerColor: "#d670b7",
      fillColor: "#d670b7",
      textColor: "#ab5892",
      highContrastColor: "#ab5892",
      textColorWord: "pink",
      highContrastColorWord: "pink",
      lineColorDarkMode: "#e377c2",
      markerColorDarkMode: "#e377c2",
      fillColorDarkMode: "#e377c2",
      textColorDarkMode: "#e377c2",
      lineWidth: 3,
      lineStyle: "dashed",
      markerStyle: "triangleRight"
    },
    8: {
      lineColor: "#7f7f7f",
      markerColor: "#7f7f7f",
      fillColor: "#7f7f7f",
      textColor: "#757575",
      highContrastColor: "#757575",
      lineColorDarkMode: "#a8a8a8",
      markerColorDarkMode: "#a8a8a8",
      fillColorDarkMode: "#a8a8a8",
      textColorDarkMode: "#a8a8a8",
      lineWidth: 1,
      lineStyle: "dotted",
      markerStyle: "circle"
    },
    9: {
      lineColor: "#6e6e12",
      markerColor: "#6e6e12",
      fillColor: "#6e6e12",
      textColor: "#6e6e12",
      highContrastColor: "#6e6e12",
      lineColorWord: "olive",
      markerColorWord: "olive",
      fillColorWord: "olive",
      textColorWord: "olive",
      highContrastColorWord: "olive",
      lineColorDarkMode: "#bcbd22",
      markerColorDarkMode: "#bcbd22",
      fillColorDarkMode: "#bcbd22",
      textColorDarkMode: "#bcbd22",
      lineColorWordDarkMode: "olive",
      markerColorWordDarkMode: "olive",
      fillColorWordDarkMode: "olive",
      textColorWordDarkMode: "olive",
      highContrastColorWordDarkMode: "olive",
      lineWidth: 2,
      lineStyle: "dashed",
      markerStyle: "square"
    },
    10: {
      lineColor: "#12a2b1",
      markerColor: "#12a2b1",
      fillColor: "#12a2b1",
      textColor: "#0c818e",
      highContrastColor: "#0c818e",
      textColorWord: "cyan",
      highContrastColorWord: "cyan",
      lineColorDarkMode: "#17becf",
      markerColorDarkMode: "#17becf",
      fillColorDarkMode: "#17becf",
      textColorDarkMode: "#17becf",
      lineWidth: 2,
      lineStyle: "dotted",
      markerStyle: "diamond"
    }
  }
};
const grumpyNarwhalPalette = {
  name: "grumpyNarwhal",
  description: "Six saturated hues — burnt orange, forest green, deep pink, arctic teal, gold, and purple — going neon in dark mode.",
  styles: {
    1: {
      lineColor: "#b34700",
      markerColor: "#b34700",
      fillColor: "#b34700",
      highContrastColor: "#b34700",
      lineColorDarkMode: "#ff5f00",
      markerColorDarkMode: "#ff5f00",
      fillColorDarkMode: "#ff5f00",
      lineColorWordDarkMode: "orange",
      markerColorWordDarkMode: "orange",
      fillColorWordDarkMode: "orange",
      lineWidth: 4,
      markerStyle: "circle"
    },
    2: {
      lineColor: "#1b7a1b",
      markerColor: "#1b7a1b",
      fillColor: "#1b7a1b",
      textColor: "#1b7a1b",
      highContrastColor: "#1b7a1b",
      lineColorDarkMode: "#39ff14",
      markerColorDarkMode: "#39ff14",
      fillColorDarkMode: "#39ff14",
      textColorDarkMode: "#39ff14",
      lineWidth: 2,
      markerStyle: "square"
    },
    3: {
      lineColor: "#c20e67",
      markerColor: "#c20e67",
      fillColor: "#c20e67",
      textColor: "#c20e67",
      highContrastColor: "#c20e67",
      lineColorWord: "pink",
      markerColorWord: "pink",
      fillColorWord: "pink",
      textColorWord: "pink",
      highContrastColorWord: "pink",
      lineColorDarkMode: "#ff1493",
      markerColorDarkMode: "#ff1493",
      fillColorDarkMode: "#ff1493",
      textColorDarkMode: "#ff1493",
      lineWidth: 3,
      markerStyle: "triangle"
    },
    4: {
      lineColor: "#007a8c",
      markerColor: "#007a8c",
      fillColor: "#007a8c",
      textColor: "#007a8c",
      highContrastColor: "#007a8c",
      lineColorWord: "teal",
      markerColorWord: "teal",
      fillColorWord: "teal",
      textColorWord: "teal",
      highContrastColorWord: "teal",
      lineColorDarkMode: "#00e5ff",
      markerColorDarkMode: "#00e5ff",
      fillColorDarkMode: "#00e5ff",
      textColorDarkMode: "#00e5ff",
      lineWidth: 2,
      markerStyle: "diamond"
    },
    5: {
      lineColor: "#8a6d00",
      markerColor: "#8a6d00",
      fillColor: "#8a6d00",
      textColor: "#8a6d00",
      highContrastColor: "#8a6d00",
      lineColorWord: "gold",
      markerColorWord: "gold",
      fillColorWord: "gold",
      textColorWord: "gold",
      highContrastColorWord: "gold",
      lineColorDarkMode: "#ffea00",
      markerColorDarkMode: "#ffea00",
      fillColorDarkMode: "#ffea00",
      textColorDarkMode: "#ffea00",
      lineWidth: 2,
      markerStyle: "triangleDown"
    },
    6: {
      // Contributed as the same purple in both modes; on Doenet's
      // lighter dark canvas that lands at 4.07:1, so the dark text
      // variant is lightened to clear 4.5:1 while lines and markers
      // keep the contributed color.
      lineColor: "#b026ff",
      markerColor: "#b026ff",
      fillColor: "#b026ff",
      textColor: "#b026ff",
      highContrastColor: "#b026ff",
      lineColorDarkMode: "#b026ff",
      markerColorDarkMode: "#b026ff",
      fillColorDarkMode: "#b026ff",
      textColorDarkMode: "#b445ff",
      highContrastColorDarkMode: "#b445ff",
      lineWidth: 2,
      markerStyle: "triangleLeft"
    }
  }
};
function deepFreezePalette(palette) {
  for (const styleDef of Object.values(palette.styles)) {
    for (const value of Object.values(styleDef)) {
      if (typeof value === "object" && value !== null) {
        Object.freeze(value);
      }
    }
    Object.freeze(styleDef);
  }
  Object.freeze(palette.styles);
  return Object.freeze(palette);
}
function registerByKey(palette) {
  return [palette.name.toLowerCase(), deepFreezePalette(palette)];
}
const STYLE_PALETTES = Object.assign(
  /* @__PURE__ */ Object.create(null),
  Object.fromEntries(
    [
      defaultPalette,
      okabeItoPalette,
      tolBrightPalette,
      tolMutedPalette,
      tolHighContrastPalette,
      ibmPalette,
      grayscalePalette,
      categoricalPalette,
      grumpyNarwhalPalette
    ].map(registerByKey)
  )
);
Object.freeze(STYLE_PALETTES);
const DEFAULT_PALETTE_NAME = defaultPalette.name.toLowerCase();
const STYLE_PALETTE_NAMES = Object.freeze(
  Object.keys(STYLE_PALETTES)
);
function cycleStyleNumberForPalette(styleNumber, paletteName) {
  const palette = STYLE_PALETTES[paletteName];
  if (!palette || !Number.isInteger(styleNumber) || styleNumber < 1) {
    return styleNumber;
  }
  const size = Object.keys(palette.styles).length;
  if (size < 1 || styleNumber <= size) {
    return styleNumber;
  }
  return (styleNumber - 1) % size + 1;
}
var o = function(o2) {
  var t2 = o2 / 255;
  return t2 < 0.04045 ? t2 / 12.92 : Math.pow((t2 + 0.055) / 1.055, 2.4);
}, t = function(t2) {
  return 0.2126 * o(t2.r) + 0.7152 * o(t2.g) + 0.0722 * o(t2.b);
};
function a11yPlugin(o2) {
  o2.prototype.luminance = function() {
    return o3 = t(this.rgba), void 0 === (r2 = 2) && (r2 = 0), void 0 === n2 && (n2 = Math.pow(10, r2)), Math.round(n2 * o3) / n2 + 0;
    var o3, r2, n2;
  }, o2.prototype.contrast = function(r2) {
    void 0 === r2 && (r2 = "#FFF");
    var n2, a2, i2, e2, v2, u2, d2, c2 = r2 instanceof o2 ? r2 : new o2(r2);
    return e2 = this.rgba, v2 = c2.toRgb(), u2 = t(e2), d2 = t(v2), n2 = u2 > d2 ? (u2 + 0.05) / (d2 + 0.05) : (d2 + 0.05) / (u2 + 0.05), void 0 === (a2 = 2) && (a2 = 0), void 0 === i2 && (i2 = Math.pow(10, a2)), Math.floor(i2 * n2) / i2 + 0;
  }, o2.prototype.isReadable = function(o3, t2) {
    return void 0 === o3 && (o3 = "#FFF"), void 0 === t2 && (t2 = {}), this.contrast(o3) >= (e2 = void 0 === (i2 = (r2 = t2).size) ? "normal" : i2, "AAA" === (a2 = void 0 === (n2 = r2.level) ? "AA" : n2) && "normal" === e2 ? 7 : "AA" === a2 && "large" === e2 ? 3 : 4.5);
    var r2, n2, a2, i2, e2;
  };
}
function namesPlugin(e2, f2) {
  var a2 = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r2 = {};
  for (var d2 in a2) r2[a2[d2]] = d2;
  var l2 = {};
  e2.prototype.toName = function(f3) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var d3, i2, n2 = r2[this.toHex()];
    if (n2) return n2;
    if (null == f3 ? void 0 : f3.closest) {
      var o2 = this.toRgb(), t2 = 1 / 0, b2 = "black";
      if (!l2.length) for (var c2 in a2) l2[c2] = new e2(a2[c2]).toRgb();
      for (var g2 in a2) {
        var u2 = (d3 = o2, i2 = l2[g2], Math.pow(d3.r - i2.r, 2) + Math.pow(d3.g - i2.g, 2) + Math.pow(d3.b - i2.b, 2));
        u2 < t2 && (t2 = u2, b2 = g2);
      }
      return b2;
    }
  };
  f2.string.push([function(f3) {
    var r3 = f3.toLowerCase(), d3 = "transparent" === r3 ? "#0000" : a2[r3];
    return d3 ? new e2(d3).toRgb() : null;
  }, "name"]);
}
k([a11yPlugin, namesPlugin]);
const CANVAS_LIGHT_MODE_COLOR = "#ffffff";
const CANVAS_DARK_MODE_COLOR = "#121212";
const CANVAS_TEXT_LIGHT_MODE_COLOR = "black";
const CANVAS_TEXT_DARK_MODE_COLOR = "white";
const GRAPHIC_CONTRAST_THRESHOLD = 3;
const TEXT_CONTRAST_THRESHOLD = 4.5;
function clamp01(value) {
  if (!Number.isFinite(value)) {
    return 1;
  }
  return value < 0 ? 0 : value > 1 ? 1 : value;
}
function compositeOver(foreground, background) {
  const a2 = clamp01(foreground.a);
  return {
    r: foreground.r * a2 + background.r * (1 - a2),
    g: foreground.g * a2 + background.g * (1 - a2),
    b: foreground.b * a2 + background.b * (1 - a2)
  };
}
function hexWithLightness(color, lightness) {
  return w$1({ ...color, l: lightness }).toHex();
}
function compositedContrastRatio({
  foreground,
  canvas,
  background,
  opacityMultiplier = 1
}) {
  const fg = w$1(foreground);
  const canvasColor = w$1(canvas);
  if (!fg.isValid() || !canvasColor.isValid()) {
    return null;
  }
  const canvasRgb = canvasColor.toRgb();
  const canvasOpaque = {
    r: canvasRgb.r,
    g: canvasRgb.g,
    b: canvasRgb.b
  };
  let backgroundOpaque = canvasOpaque;
  if (background !== void 0) {
    const bg = w$1(background);
    if (!bg.isValid()) {
      return null;
    }
    backgroundOpaque = compositeOver(bg.toRgb(), canvasOpaque);
  }
  const fgRgba = fg.toRgb();
  const effectiveForeground = compositeOver(
    { ...fgRgba, a: clamp01(fgRgba.a * opacityMultiplier) },
    backgroundOpaque
  );
  return w$1(effectiveForeground).contrast(w$1(backgroundOpaque));
}
function deriveAccessibleDarkModeColor({
  lightColor,
  threshold,
  opacityMultiplier = 1
}) {
  const base = w$1(lightColor);
  if (!base.isValid()) {
    return lightColor;
  }
  const currentRatio = compositedContrastRatio({
    foreground: lightColor,
    canvas: CANVAS_DARK_MODE_COLOR,
    opacityMultiplier
  });
  if (currentRatio !== null && currentRatio >= threshold) {
    return lightColor;
  }
  const { h: h2, s: s2, l: startL, a: a2 } = base.toHsl();
  for (let l2 = Math.ceil(startL); l2 <= 100; l2++) {
    const candidate = hexWithLightness({ h: h2, s: s2, a: a2 }, l2);
    const ratio = compositedContrastRatio({
      foreground: candidate,
      canvas: CANVAS_DARK_MODE_COLOR,
      opacityMultiplier
    });
    if (ratio !== null && ratio >= threshold) {
      return candidate;
    }
  }
  return hexWithLightness({ h: h2, s: s2, a: a2 }, 100);
}
function invertLightness(color) {
  const c2 = w$1(color);
  if (!c2.isValid()) {
    return color;
  }
  const { h: h2, s: s2, l: l2, a: a2 } = c2.toHsl();
  return w$1({ h: h2, s: s2, l: 100 - l2, a: a2 }).toHex();
}
function deriveAccessibleDarkModeBackground(lightColor) {
  return invertLightness(lightColor);
}
function suggestAccessibleDarkModeColorAgainst({
  startColor,
  partnerColor,
  channelRole,
  threshold
}) {
  const base = w$1(startColor);
  if (!base.isValid()) {
    return null;
  }
  const { h: h2, s: s2, l: startL, a: a2 } = base.toHsl();
  const ratioAtLightness = (candidateL) => {
    const candidate = hexWithLightness({ h: h2, s: s2, a: a2 }, candidateL);
    return channelRole === "text" ? compositedContrastRatio({
      foreground: candidate,
      canvas: CANVAS_DARK_MODE_COLOR,
      background: partnerColor
    }) : compositedContrastRatio({
      foreground: partnerColor,
      canvas: CANVAS_DARK_MODE_COLOR,
      background: candidate
    });
  };
  const roundedStart = Math.round(startL);
  for (let delta = 0; delta <= 100; delta++) {
    const candidates = delta === 0 ? [roundedStart] : [roundedStart + delta, roundedStart - delta];
    for (const candidateL of candidates) {
      if (candidateL < 0 || candidateL > 100) {
        continue;
      }
      const ratio = ratioAtLightness(candidateL);
      if (ratio !== null && ratio >= threshold) {
        return hexWithLightness({ h: h2, s: s2, a: a2 }, candidateL);
      }
    }
  }
  return null;
}
const CANVAS_FOR_MODE = {
  light: CANVAS_LIGHT_MODE_COLOR,
  dark: CANVAS_DARK_MODE_COLOR
};
function appendContrastAccessibilityDiagnosticIfNeeded({
  diagnostics,
  styleNumber,
  context,
  mode,
  ratio,
  threshold,
  position
}) {
  if (ratio === null || ratio >= threshold || !position) {
    return;
  }
  diagnostics.push(
    codedDiagnostic({
      type: "accessibility",
      level: 1,
      code: "doenet-a0007",
      args: { styleNumber, context, mode, ratio, threshold },
      position
    })
  );
}
function colorKey(item, mode) {
  return mode === "dark" ? `${item}ColorDarkMode` : `${item}Color`;
}
function contrastDiagnosticsForMode(styleNumber, styleDef, mode) {
  const diagnostics = [];
  const canvas = CANVAS_FOR_MODE[mode];
  const textColor = getStyleValueString(styleDef, colorKey("text", mode));
  const backgroundColor = getStyleValueString(
    styleDef,
    colorKey("background", mode)
  );
  if (textColor) {
    const textPosition = styleDef[colorKey("text", mode)]?.position;
    const diagnosticPosition = latestPosition(
      textPosition,
      styleDef[colorKey("background", mode)]?.position
    );
    const ratio = compositedContrastRatio({
      foreground: textColor,
      canvas,
      background: backgroundColor
    });
    appendContrastAccessibilityDiagnosticIfNeeded({
      diagnostics,
      styleNumber,
      context: backgroundColor ? "text-on-background" : "text-on-canvas",
      mode,
      ratio,
      threshold: TEXT_CONTRAST_THRESHOLD,
      position: diagnosticPosition
    });
  }
  const highContrastColor = getStyleValueString(
    styleDef,
    colorKey("highContrast", mode)
  );
  if (highContrastColor) {
    const highContrastPosition = styleDef[colorKey("highContrast", mode)]?.position;
    const ratio = compositedContrastRatio({
      foreground: highContrastColor,
      canvas
    });
    appendContrastAccessibilityDiagnosticIfNeeded({
      diagnostics,
      styleNumber,
      context: "high-contrast",
      mode,
      ratio,
      threshold: TEXT_CONTRAST_THRESHOLD,
      position: highContrastPosition
    });
  }
  const lineColor = getStyleValueString(styleDef, colorKey("line", mode));
  if (lineColor) {
    const linePosition = styleDef[colorKey("line", mode)]?.position;
    const diagnosticPosition = latestPosition(
      linePosition,
      styleDef.lineOpacity?.position
    );
    const lineOpacity = getStyleValueNumber(styleDef, "lineOpacity") ?? DEFAULT_STYLE_VALUES.lineOpacity;
    const ratio = compositedContrastRatio({
      foreground: lineColor,
      canvas,
      opacityMultiplier: lineOpacity
    });
    appendContrastAccessibilityDiagnosticIfNeeded({
      diagnostics,
      styleNumber,
      context: "line",
      mode,
      ratio,
      threshold: GRAPHIC_CONTRAST_THRESHOLD,
      position: diagnosticPosition
    });
  }
  const markerColor = getStyleValueString(styleDef, colorKey("marker", mode));
  if (markerColor) {
    const markerPosition = styleDef[colorKey("marker", mode)]?.position;
    const diagnosticPosition = latestPosition(
      markerPosition,
      styleDef.markerOpacity?.position
    );
    const markerOpacity = getStyleValueNumber(styleDef, "markerOpacity") ?? DEFAULT_STYLE_VALUES.markerOpacity;
    const ratio = compositedContrastRatio({
      foreground: markerColor,
      canvas,
      opacityMultiplier: markerOpacity
    });
    appendContrastAccessibilityDiagnosticIfNeeded({
      diagnostics,
      styleNumber,
      context: "marker",
      mode,
      ratio,
      threshold: GRAPHIC_CONTRAST_THRESHOLD,
      position: diagnosticPosition
    });
  }
  return diagnostics;
}
function derivedDarkModeCombinationDiagnostics(styleNumber, styleDef) {
  const textLight = getStyleValueString(styleDef, "textColor");
  const backgroundLight = getStyleValueString(styleDef, "backgroundColor");
  const textDark = getStyleValueString(styleDef, "textColorDarkMode");
  const backgroundDark = getStyleValueString(
    styleDef,
    "backgroundColorDarkMode"
  );
  if (!textLight || !backgroundLight || !textDark || !backgroundDark) {
    return [];
  }
  if (styleDef.textColorDarkMode?.position || styleDef.backgroundColorDarkMode?.position) {
    return [];
  }
  const lightRatio = compositedContrastRatio({
    foreground: textLight,
    canvas: CANVAS_LIGHT_MODE_COLOR,
    background: backgroundLight
  });
  const darkRatio = compositedContrastRatio({
    foreground: textDark,
    canvas: CANVAS_DARK_MODE_COLOR,
    background: backgroundDark
  });
  if (lightRatio === null || darkRatio === null || lightRatio < TEXT_CONTRAST_THRESHOLD || darkRatio >= TEXT_CONTRAST_THRESHOLD) {
    return [];
  }
  const textPosition = styleDef.textColor?.position;
  const backgroundPosition = styleDef.backgroundColor?.position;
  const position = latestPosition(textPosition, backgroundPosition);
  if (!position) {
    return [];
  }
  const squiggledChannel = backgroundPosition && position === backgroundPosition ? "background" : "text";
  const channelsToTry = squiggledChannel === "background" ? ["background", "text"] : ["text", "background"];
  let suggestion;
  for (const channel of channelsToTry) {
    const color = suggestAccessibleDarkModeColorAgainst({
      startColor: channel === "text" ? textDark : backgroundDark,
      partnerColor: channel === "text" ? backgroundDark : textDark,
      channelRole: channel,
      threshold: TEXT_CONTRAST_THRESHOLD
    });
    if (color) {
      suggestion = {
        lightAttribute: channel === "text" ? "textColor" : "backgroundColor",
        darkAttribute: channel === "text" ? "textColorDarkMode" : "backgroundColorDarkMode",
        darkColor: color
      };
      break;
    }
  }
  return [
    codedDiagnostic({
      type: "accessibility",
      level: 1,
      code: "doenet-a0008",
      args: {
        styleNumber,
        ratio: darkRatio,
        threshold: TEXT_CONTRAST_THRESHOLD,
        ...suggestion ? {
          suggestion: "available",
          lightAttribute: suggestion.lightAttribute,
          // The dark color is derived from the light color by
          // inverting its lightness, and that inversion is its
          // own inverse — so a light value that derives to the
          // accessible dark color is just the inverted dark
          // color. Offering both lets the author keep their
          // dark color and fix the light contrast, or keep
          // their light color and override the dark one.
          lightColor: invertLightness(suggestion.darkColor),
          darkAttribute: suggestion.darkAttribute,
          darkColor: suggestion.darkColor
        } : { suggestion: "none" }
      },
      position
    })
  ];
}
function derivedDarkModeTextCanvasDiagnostics(styleNumber, styleDef) {
  const textLight = getStyleValueString(styleDef, "textColor");
  const textDark = getStyleValueString(styleDef, "textColorDarkMode");
  if (!textLight || !textDark || getStyleValueString(styleDef, "backgroundColor") || getStyleValueString(styleDef, "backgroundColorDarkMode") || styleDef.textColorDarkMode?.position) {
    return [];
  }
  const position = styleDef.textColor?.position;
  if (!position) {
    return [];
  }
  const lightRatio = compositedContrastRatio({
    foreground: textLight,
    canvas: CANVAS_LIGHT_MODE_COLOR
  });
  const darkRatio = compositedContrastRatio({
    foreground: textDark,
    canvas: CANVAS_DARK_MODE_COLOR
  });
  if (lightRatio === null || darkRatio === null || lightRatio < TEXT_CONTRAST_THRESHOLD || darkRatio >= TEXT_CONTRAST_THRESHOLD) {
    return [];
  }
  const suggestedDark = deriveAccessibleDarkModeColor({
    lightColor: textDark,
    threshold: TEXT_CONTRAST_THRESHOLD
  });
  const suggestedDarkRatio = compositedContrastRatio({
    foreground: suggestedDark,
    canvas: CANVAS_DARK_MODE_COLOR
  });
  const haveSuggestion = suggestedDarkRatio !== null && suggestedDarkRatio >= TEXT_CONTRAST_THRESHOLD;
  return [
    codedDiagnostic({
      type: "accessibility",
      level: 1,
      code: "doenet-a0009",
      args: {
        styleNumber,
        ratio: darkRatio,
        threshold: TEXT_CONTRAST_THRESHOLD,
        ...haveSuggestion ? {
          suggestion: "available",
          lightColor: invertLightness(suggestedDark),
          darkColor: suggestedDark
        } : { suggestion: "none" }
      },
      position
    })
  ];
}
function contrastAccessibilityDiagnosticsForStyleDefinition(styleNumber, styleDef) {
  return [
    ...contrastDiagnosticsForMode(styleNumber, styleDef, "light"),
    ...contrastDiagnosticsForMode(styleNumber, styleDef, "dark"),
    ...derivedDarkModeCombinationDiagnostics(styleNumber, styleDef),
    ...derivedDarkModeTextCanvasDiagnostics(styleNumber, styleDef)
  ];
}
function contrastAccessibilityDiagnosticsForStyleDefinitions(styleDefinitions) {
  const diagnostics = [];
  for (const styleNumber in styleDefinitions) {
    diagnostics.push(
      ...contrastAccessibilityDiagnosticsForStyleDefinition(
        styleNumber,
        styleDefinitions[styleNumber]
      )
    );
  }
  return diagnostics;
}
function resolveReaderPaletteName(overrides) {
  const raw = overrides?.palette;
  if (typeof raw !== "string") {
    return null;
  }
  const name = raw.trim().toLowerCase();
  return name in STYLE_PALETTES ? name : null;
}
let styleAttributes = {
  lineColor: {
    componentType: "text",
    description: "Color used for line strokes (light mode)."
  },
  lineColorWord: {
    componentType: "text",
    description: "Human-readable name of the line color (light mode)."
  },
  lineColorDarkMode: {
    componentType: "text",
    description: "Color used for line strokes (dark mode)."
  },
  lineColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the line color (dark mode)."
  },
  lineOpacity: {
    componentType: "number",
    description: "Opacity of line strokes, 0 to 1."
  },
  lineWidth: {
    componentType: "number",
    description: "Stroke width for lines, in pixels."
  },
  lineWidthWord: {
    componentType: "text",
    description: "Human-readable name of the line width."
  },
  lineStyle: {
    componentType: "text",
    description: "Stroke style for lines.",
    toLowerCase: true,
    validValues: [
      { value: "solid", description: "Continuous, unbroken stroke." },
      {
        value: "dashed",
        description: "Stroke composed of evenly-spaced dashes."
      },
      {
        value: "dotted",
        description: "Stroke composed of evenly-spaced dots."
      }
    ]
  },
  lineStyleWord: {
    componentType: "text",
    description: "Human-readable name of the line style."
  },
  markerColor: {
    componentType: "text",
    description: "Color used for markers/points (light mode)."
  },
  markerColorWord: {
    componentType: "text",
    description: "Human-readable name of the marker color (light mode)."
  },
  markerColorDarkMode: {
    componentType: "text",
    description: "Color used for markers/points (dark mode)."
  },
  markerColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the marker color (dark mode)."
  },
  markerOpacity: {
    componentType: "number",
    description: "Opacity of markers/points, 0 to 1."
  },
  markerStyle: {
    componentType: "text",
    description: "Marker shape.",
    toLowerCase: true,
    validValues: [
      { value: "circle", description: "Circular marker." },
      { value: "square", description: "Square marker." },
      {
        value: "triangle",
        description: 'Triangular marker pointing up (alias for "triangleUp").'
      },
      {
        value: "triangleUp",
        description: "Triangular marker pointing up."
      },
      {
        value: "triangleDown",
        description: "Triangular marker pointing down."
      },
      {
        value: "triangleLeft",
        description: "Triangular marker pointing left."
      },
      {
        value: "triangleRight",
        description: "Triangular marker pointing right."
      },
      { value: "diamond", description: "Diamond-shaped marker." },
      { value: "cross", description: "Cross-shaped marker (×)." },
      { value: "plus", description: "Plus-shaped marker (+)." }
    ]
  },
  markerStyleWord: {
    componentType: "text",
    description: "Human-readable name of the marker style."
  },
  markerSize: {
    componentType: "number",
    description: "Marker size in pixels."
  },
  markerFilled: {
    componentType: "boolean",
    description: "Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior."
  },
  fillColor: {
    componentType: "text",
    description: "Fill color used inside closed shapes (light mode)."
  },
  fillColorWord: {
    componentType: "text",
    description: "Human-readable name of the fill color (light mode)."
  },
  fillColorDarkMode: {
    componentType: "text",
    description: "Fill color used inside closed shapes (dark mode)."
  },
  fillColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the fill color (dark mode)."
  },
  fillOpacity: {
    componentType: "number",
    description: "Opacity of solid fills, 0 to 1."
  },
  fillPatternOpacity: {
    componentType: "number",
    description: "Opacity of pattern fills (non-solid fillStyle), 0 to 1."
  },
  fillStyle: {
    componentType: "text",
    description: "Fill pattern used inside closed shapes.",
    toLowerCase: true,
    validValues: [
      { value: "solid", description: "Solid fill." },
      {
        value: "horizontal",
        description: "Horizontal line pattern."
      },
      {
        value: "vertical",
        description: "Vertical line pattern."
      },
      {
        value: "diagonal",
        description: "Diagonal line pattern (/)."
      },
      {
        value: "backDiagonal",
        description: "Back-diagonal line pattern (\\)."
      },
      {
        value: "dots",
        description: "Dots pattern."
      },
      {
        value: "diamonds",
        description: "Filled diamonds pattern."
      }
    ]
  },
  fillStyleWord: {
    componentType: "text",
    description: "Human-readable name of the fill style."
  },
  textColor: {
    componentType: "text",
    description: "Text color (light mode)."
  },
  textColorWord: {
    componentType: "text",
    description: "Human-readable name of the text color (light mode)."
  },
  textColorDarkMode: {
    componentType: "text",
    description: "Text color (dark mode)."
  },
  textColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the text color (dark mode)."
  },
  highContrastColor: {
    componentType: "text",
    description: "High-contrast accent color (light mode)."
  },
  highContrastColorWord: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (light mode)."
  },
  highContrastColorDarkMode: {
    componentType: "text",
    description: "High-contrast accent color (dark mode)."
  },
  highContrastColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (dark mode)."
  },
  backgroundColor: {
    componentType: "text",
    description: "Background color (light mode)."
  },
  backgroundColorWord: {
    componentType: "text",
    description: "Human-readable name of the background color (light mode)."
  },
  backgroundColorDarkMode: {
    componentType: "text",
    description: "Background color (dark mode)."
  },
  backgroundColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the background color (dark mode)."
  }
};
const markerStyleValuesWithFillVariants = styleAttributes.markerStyle.validValues.filter(
  (entry) => entry.value !== "cross" && entry.value !== "plus"
);
const MARKER_OVERRIDE_KEYS = [
  "markerStyle",
  "markerSize",
  "markerFilled"
];
const LINE_OVERRIDE_KEYS = [
  "lineStyle",
  "lineWidth"
];
const FILL_OVERRIDE_KEYS = [
  "fillOpacity",
  "fillPatternOpacity",
  "fillStyle"
];
const markerOverrideAttributes = Object.fromEntries(
  MARKER_OVERRIDE_KEYS.map((key) => [key, styleAttributes[key]])
);
const lineOverrideAttributes = Object.fromEntries(
  LINE_OVERRIDE_KEYS.map((key) => [key, styleAttributes[key]])
);
const fillOverrideAttributes = Object.fromEntries(
  FILL_OVERRIDE_KEYS.map((key) => [key, styleAttributes[key]])
);
const styleOverrideAttributes = {
  ...markerOverrideAttributes,
  ...lineOverrideAttributes,
  ...fillOverrideAttributes
};
const STYLE_OVERRIDE_CATEGORIES = {
  marker: markerOverrideAttributes,
  line: lineOverrideAttributes,
  fill: fillOverrideAttributes
};
for (const [category, group] of Object.entries(STYLE_OVERRIDE_CATEGORIES)) {
  for (const [key, spec] of Object.entries(group)) {
    if (key.toLowerCase().includes("color")) {
      throw new Error(
        `Style override category "${category}" contains color-related key "${key}"; colors stay <styleDefinition>-only so per-styleNumber WCAG contrast diagnostics remain authoritative. If this is intentional, also reconcile the lowercase asymmetry in returnSelectedStyleStateVariableDefinition.`
      );
    }
    if (key.endsWith("Opacity") && key !== "fillOpacity" && key !== "fillPatternOpacity") {
      throw new Error(
        `Style override category "${category}" contains contrast-feeding opacity key "${key}"; lineOpacity and markerOpacity feed the WCAG contrast diagnostic as an opacityMultiplier on the foreground alpha, so they stay <styleDefinition>-only alongside colors. Only fillOpacity and fillPatternOpacity are contrast-irrelevant and overridable.`
      );
    }
    if (spec.componentType === "text" && !spec.toLowerCase) {
      throw new Error(
        `Style override key "${key}" in category "${category}" is text-typed but missing toLowerCase: true. Add toLowerCase: true to its styleAttributes entry, or move it out of the override surface.`
      );
    }
  }
}
function attributeSpecFromStyleAttribute(spec) {
  const attr = {
    createComponentOfType: spec.componentType,
    description: spec.description
  };
  if (spec.validValues) {
    attr.validValues = spec.validValues;
  }
  if (spec.toLowerCase) {
    attr.toLowerCase = spec.toLowerCase;
  }
  return attr;
}
let defaultStyle = { ...DEFAULT_STYLE_VALUES };
const coloredItemsForWords = [
  "line",
  "marker",
  "fill",
  "text",
  "highContrast",
  "background"
];
function addMissingColorWordsToStyleDefinition(styleDef) {
  for (const item of coloredItemsForWords) {
    const colorKey2 = `${item}Color`;
    const colorWordKey = `${colorKey2}Word`;
    const darkKey = `${colorKey2}DarkMode`;
    const darkWordKey = `${colorWordKey}DarkMode`;
    const colorValue = getStyleValueString(styleDef, colorKey2);
    if (!(colorWordKey in styleDef) && colorValue) {
      setStyleValue(styleDef, colorWordKey, colorValueToWord(colorValue));
    }
    const darkColorValue = getStyleValueString(styleDef, darkKey);
    if (!(darkWordKey in styleDef) && darkColorValue) {
      setStyleValue(
        styleDef,
        darkWordKey,
        colorValueToWord(darkColorValue)
      );
    }
  }
  return styleDef;
}
function cloneDefaultStyleWithMissingColorWords() {
  return addMissingColorWordsToStyleDefinition(
    normalizeStyleDefinitionValues(Object.assign({}, defaultStyle))
  );
}
function deriveDarkModeColorForItem(item, lightColor, styleDef) {
  if (item === "background") {
    return deriveAccessibleDarkModeBackground(lightColor);
  }
  if (item === "text") {
    return invertLightness(lightColor);
  }
  if (item === "highContrast") {
    return deriveAccessibleDarkModeColor({
      lightColor,
      threshold: TEXT_CONTRAST_THRESHOLD
    });
  }
  if (item === "line" || item === "marker") {
    const opacityKey = `${item}Opacity`;
    const opacityDefault = DEFAULT_STYLE_VALUES[opacityKey];
    const opacity = getStyleValueNumber(styleDef, opacityKey) ?? opacityDefault ?? 1;
    return deriveAccessibleDarkModeColor({
      lightColor,
      threshold: GRAPHIC_CONTRAST_THRESHOLD,
      opacityMultiplier: opacity
    });
  }
  return deriveAccessibleDarkModeColor({
    lightColor,
    threshold: GRAPHIC_CONTRAST_THRESHOLD
  });
}
function addMissingChildStyleColorFields(styleDef) {
  for (const item of coloredItemsForWords) {
    deriveMissingDarkModeColor(styleDef, item);
  }
  return addMissingColorWordsToStyleDefinition(styleDef);
}
function deriveMissingDarkModeColor(styleDef, item) {
  const colorKey2 = `${item}Color`;
  const darkKey = `${colorKey2}DarkMode`;
  if (!(colorKey2 in styleDef) || darkKey in styleDef) {
    return;
  }
  const colorValue = getStyleValueString(styleDef, colorKey2);
  if (colorValue === void 0) {
    return;
  }
  const darkColor = deriveDarkModeColorForItem(item, colorValue, styleDef);
  setStyleValue(styleDef, darkKey, darkColor);
}
function deriveMissingStyleWords(styleDef) {
  if ("lineWidth" in styleDef && !("lineWidthWord" in styleDef)) {
    const widthValue = getStyleValueNumber(styleDef, "lineWidth");
    if (widthValue !== void 0) {
      const widthPosition = styleDef.lineWidth?.position;
      const word = widthValue >= 4 ? "thick" : widthValue <= 1 ? "thin" : "";
      setStyleValue(styleDef, "lineWidthWord", word, widthPosition);
    }
  }
  if ("lineStyle" in styleDef && !("lineStyleWord" in styleDef)) {
    const lineStyle = getStyleValueString(styleDef, "lineStyle");
    if (lineStyle) {
      const lineStylePosition = styleDef.lineStyle?.position;
      const word = lineStyle === "dashed" ? "dashed" : lineStyle === "dotted" ? "dotted" : "";
      setStyleValue(styleDef, "lineStyleWord", word, lineStylePosition);
    }
  }
  if ("markerStyle" in styleDef && !("markerStyleWord" in styleDef)) {
    const markerStyle = getStyleValueString(styleDef, "markerStyle");
    const markerStylePosition = styleDef.markerStyle?.position;
    if (markerStyle) {
      setStyleValue(
        styleDef,
        "markerStyleWord",
        markerStyle,
        markerStylePosition
      );
    }
    const markerStyleWord = getStyleValueString(
      styleDef,
      "markerStyleWord"
    );
    if (markerStyleWord === "circle") {
      setStyleValue(
        styleDef,
        "markerStyleWord",
        "point",
        markerStylePosition
      );
    } else if (markerStyleWord && markerStyleWord.slice(0, 8) === "triangle") {
      setStyleValue(
        styleDef,
        "markerStyleWord",
        "triangle",
        markerStylePosition
      );
    }
  }
  if ("fillStyle" in styleDef && !("fillStyleWord" in styleDef)) {
    const fillStyle = getStyleValueString(styleDef, "fillStyle");
    if (fillStyle) {
      const fillStylePosition = styleDef.fillStyle?.position;
      const fillStyleWordMap = {
        solid: "",
        horizontal: "horizontal lines",
        vertical: "vertical lines",
        diagonal: "diagonal lines",
        backdiagonal: "reverse diagonal lines",
        dots: "dots",
        diamonds: "diamonds"
      };
      const word = fillStyleWordMap[fillStyle] ?? "";
      setStyleValue(styleDef, "fillStyleWord", word, fillStylePosition);
    }
  }
}
function expandStylePalette(palette) {
  const styleDefinitions = normalizeStyleDefinitionsValues(palette.styles);
  for (const [styleNumber, styleDef] of Object.entries(styleDefinitions)) {
    lowercaseEnumStyleValues(styleDef);
    if (styleNumber === NEUTRAL_TEXT_STYLE_NUMBER) {
      applyNeutralTextColor(styleDef);
    }
    applyFullGraphicOpacity(styleDef);
    pairDarkModeHighContrastWithText(styleDef);
    addMissingChildStyleColorFields(styleDef);
    deriveMissingStyleWords(styleDef);
  }
  return styleDefinitions;
}
const NEUTRAL_TEXT_STYLE_NUMBER = "1";
function applyNeutralTextColor(styleDef) {
  setStyleValue(styleDef, "textColor", CANVAS_TEXT_LIGHT_MODE_COLOR);
  setStyleValue(styleDef, "textColorDarkMode", CANVAS_TEXT_DARK_MODE_COLOR);
  delete styleDef.textColorWord;
  delete styleDef.textColorWordDarkMode;
}
const LOWERCASED_STYLE_KEYS = Object.entries(styleAttributes).filter(([, spec]) => spec.toLowerCase).map(([key]) => key);
function lowercaseEnumStyleValues(styleDef) {
  for (const key of LOWERCASED_STYLE_KEYS) {
    const value = getStyleValueString(styleDef, key);
    if (value !== void 0 && value !== value.toLowerCase()) {
      setStyleValue(styleDef, key, value.toLowerCase());
    }
  }
}
function applyFullGraphicOpacity(styleDef) {
  for (const key of ["lineOpacity", "markerOpacity"]) {
    if (!(key in styleDef)) {
      setStyleValue(styleDef, key, 1);
    }
  }
}
function pairDarkModeHighContrastWithText(styleDef) {
  if ("highContrastColorDarkMode" in styleDef) {
    return;
  }
  const textColorDarkMode = getStyleValueString(
    styleDef,
    "textColorDarkMode"
  );
  if (textColorDarkMode === void 0) {
    return;
  }
  const textColor = getStyleValueString(styleDef, "textColor");
  const highContrastColor = getStyleValueString(
    styleDef,
    "highContrastColor"
  );
  if (textColor === void 0 || highContrastColor === void 0 || textColor.toLowerCase() !== highContrastColor.toLowerCase()) {
    return;
  }
  setStyleValue(styleDef, "highContrastColorDarkMode", textColorDarkMode);
}
function returnPaletteStyleDefinitions(paletteName) {
  const palette = STYLE_PALETTES[paletteName] ?? STYLE_PALETTES[DEFAULT_PALETTE_NAME];
  return expandStylePalette(palette);
}
function returnDefaultStyleDefinitions() {
  return returnPaletteStyleDefinitions(DEFAULT_PALETTE_NAME);
}
function childrenExpandingSetups(dependencyValues, mixedChildren, perSetupPrefix) {
  const out = [];
  for (const child of mixedChildren) {
    if (child.componentType === "setup") {
      out.push(
        ...dependencyValues[`${perSetupPrefix}${child.componentIdx}`]
      );
    } else {
      out.push(child);
    }
  }
  return out;
}
function normalizeReaderStyleValue(key, value) {
  switch (styleAttributes[key]?.componentType) {
    case "number": {
      const num = typeof value === "number" ? value : typeof value === "string" && value.trim() !== "" ? Number(value) : NaN;
      return Number.isFinite(num) ? num : void 0;
    }
    case "boolean": {
      if (typeof value === "boolean") {
        return value;
      }
      if (typeof value === "string") {
        const lowered = value.toLowerCase();
        if (lowered === "true") {
          return true;
        }
        if (lowered === "false") {
          return false;
        }
      }
      return void 0;
    }
    default:
      return typeof value === "string" ? value.toLowerCase() : void 0;
  }
}
function applyReaderStyleOverrides(styleDefinitions, overrides) {
  const hasOwn = Object.prototype.hasOwnProperty;
  const readerPaletteName = resolveReaderPaletteName(overrides);
  if (readerPaletteName != null) {
    for (const styleNumber of Object.keys(styleDefinitions)) {
      delete styleDefinitions[styleNumber];
    }
    Object.assign(
      styleDefinitions,
      returnPaletteStyleDefinitions(readerPaletteName)
    );
  }
  const styles = overrides?.styles;
  if (!styles || typeof styles !== "object") {
    return;
  }
  for (const [styleNumber, valueOverrides] of Object.entries(styles)) {
    if (!hasOwn.call(styleDefinitions, styleNumber)) {
      continue;
    }
    const target = styleDefinitions[styleNumber];
    if (!target || !valueOverrides || typeof valueOverrides !== "object") {
      continue;
    }
    const block = {};
    for (const [key, value] of Object.entries(valueOverrides)) {
      if (!hasOwn.call(styleAttributes, key) || key.includes("Word")) {
        continue;
      }
      const normalized = normalizeReaderStyleValue(
        key,
        value
      );
      if (normalized === void 0) {
        continue;
      }
      setStyleValue(block, key, normalized);
    }
    if (Object.keys(block).length === 0) {
      continue;
    }
    addMissingChildStyleColorFields(block);
    deriveMissingStyleWords(block);
    Object.assign(target, block);
  }
}
function returnStyleDefinitionStateVariables() {
  let stateVariableDefinitions = {};
  stateVariableDefinitions.setupChildren = {
    returnDependencies: () => ({
      setupChildren: {
        dependencyType: "child",
        childGroups: ["setups"],
        proceedIfAllChildrenNotMatched: true
      }
    }),
    definition({ dependencyValues }) {
      return {
        setValue: { setupChildren: dependencyValues.setupChildren }
      };
    }
  };
  stateVariableDefinitions.readerStyleOverrides = {
    hasEssential: true,
    defaultValue: null,
    returnDependencies: () => ({
      documentAncestor: {
        dependencyType: "ancestor",
        componentType: "document",
        variableNames: ["readerStyleOverrides"]
      }
    }),
    definition({ dependencyValues }) {
      if (dependencyValues.documentAncestor) {
        return {
          setValue: {
            readerStyleOverrides: dependencyValues.documentAncestor.stateValues.readerStyleOverrides
          }
        };
      } else {
        return {
          useEssentialOrDefaultValue: { readerStyleOverrides: true }
        };
      }
    },
    inverseDefinition({
      desiredStateVariableValues,
      dependencyValues
    }) {
      if (dependencyValues.documentAncestor) {
        return {
          success: true,
          instructions: [
            {
              setDependency: "documentAncestor",
              desiredValue: desiredStateVariableValues.readerStyleOverrides
            }
          ]
        };
      } else {
        return {
          success: true,
          instructions: [
            {
              setEssentialValue: "readerStyleOverrides",
              value: desiredStateVariableValues.readerStyleOverrides
            }
          ]
        };
      }
    }
  };
  stateVariableDefinitions.localStylePaletteName = {
    stateVariablesDeterminingDependencies: ["setupChildren"],
    returnDependencies({ stateValues }) {
      let dependencies = {
        stylePaletteSetupChildren: {
          dependencyType: "child",
          childGroups: ["stylePalettes", "setups"],
          variableNames: ["palette"],
          variablesOptional: true,
          proceedIfAllChildrenNotMatched: true
        }
      };
      for (let setupChild of stateValues.setupChildren) {
        dependencies[`stylePalettesOf${setupChild.componentIdx}`] = {
          dependencyType: "child",
          parentIdx: setupChild.componentIdx,
          childGroups: ["stylePalettes"],
          variableNames: ["palette"]
        };
      }
      return dependencies;
    },
    definition({ dependencyValues }) {
      const stylePaletteChildren = childrenExpandingSetups(
        dependencyValues,
        dependencyValues.stylePaletteSetupChildren,
        "stylePalettesOf"
      );
      if (stylePaletteChildren.length === 0) {
        return { setValue: { localStylePaletteName: null } };
      }
      const diagnostics = [];
      if (stylePaletteChildren.length > 1) {
        for (const child of stylePaletteChildren.slice(0, -1)) {
          diagnostics.push(
            codedDiagnostic({
              type: "warning",
              code: "doenet-w0083",
              position: child.position
            })
          );
        }
      }
      const localStylePaletteName = stylePaletteChildren[stylePaletteChildren.length - 1].stateValues.palette;
      return {
        setValue: { localStylePaletteName },
        sendDiagnostics: diagnostics
      };
    }
  };
  stateVariableDefinitions.activeStylePaletteName = {
    returnDependencies: () => ({
      localStylePaletteName: {
        dependencyType: "stateVariable",
        variableName: "localStylePaletteName"
      },
      ancestorWithStyle: {
        dependencyType: "ancestor",
        variableNames: ["activeStylePaletteName"]
      }
    }),
    definition({ dependencyValues }) {
      const activeStylePaletteName = dependencyValues.localStylePaletteName ?? dependencyValues.ancestorWithStyle?.stateValues.activeStylePaletteName ?? null;
      return { setValue: { activeStylePaletteName } };
    }
  };
  stateVariableDefinitions.authoredStyleDefinitions = {
    // Always evaluated so the diagnostics side effect reliably runs.
    mustEvaluate: true,
    stateVariablesDeterminingDependencies: ["setupChildren"],
    returnDependencies({ stateValues }) {
      let dependencies = {
        ancestorWithStyle: {
          dependencyType: "ancestor",
          variableNames: ["authoredStyleDefinitions"]
        },
        localStylePaletteName: {
          dependencyType: "stateVariable",
          variableName: "localStylePaletteName"
        },
        activeStylePaletteName: {
          dependencyType: "stateVariable",
          variableName: "activeStylePaletteName"
        },
        styleDefinitionSetupChildren: {
          dependencyType: "child",
          childGroups: ["styleDefinitions", "setups"],
          variableNames: ["styleNumber", "styleDefinition"],
          variablesOptional: true,
          proceedIfAllChildrenNotMatched: true
        }
      };
      for (let setupChild of stateValues.setupChildren) {
        dependencies[`styleDefinitionsOf${setupChild.componentIdx}`] = {
          dependencyType: "child",
          parentIdx: setupChild.componentIdx,
          childGroups: ["styleDefinitions"],
          variableNames: ["styleNumber", "styleDefinition"]
        };
      }
      return dependencies;
    },
    definition({ dependencyValues }) {
      const styleDefinitions = {};
      let startingStateVariableDefinitions;
      if (dependencyValues.localStylePaletteName != null) {
        startingStateVariableDefinitions = returnPaletteStyleDefinitions(
          dependencyValues.localStylePaletteName
        );
      } else if (dependencyValues.ancestorWithStyle) {
        startingStateVariableDefinitions = dependencyValues.ancestorWithStyle.stateValues.authoredStyleDefinitions;
      }
      if (!startingStateVariableDefinitions) {
        startingStateVariableDefinitions = returnDefaultStyleDefinitions();
      }
      for (const styleNumber in startingStateVariableDefinitions) {
        styleDefinitions[styleNumber] = normalizeStyleDefinitionValues(
          Object.assign(
            {},
            startingStateVariableDefinitions[styleNumber]
          )
        );
      }
      const styleDefinitionChildren = childrenExpandingSetups(
        dependencyValues,
        dependencyValues.styleDefinitionSetupChildren,
        "styleDefinitionsOf"
      );
      for (const child of styleDefinitionChildren) {
        const styleNumber = child.stateValues.styleNumber;
        let styleDef = styleDefinitions[styleNumber];
        if (!styleDef) {
          let seed;
          if (dependencyValues.activeStylePaletteName != null) {
            const cycledNumber = cycleStyleNumberForPalette(
              styleNumber,
              dependencyValues.activeStylePaletteName
            );
            const cycledDef = styleDefinitions[cycledNumber];
            if (cycledDef) {
              seed = normalizeStyleDefinitionValues(
                Object.assign({}, cycledDef)
              );
            }
          }
          styleDef = styleDefinitions[styleNumber] = seed ?? cloneDefaultStyleWithMissingColorWords();
        }
        const theNewDef = normalizeStyleDefinitionValues(
          Object.assign({}, child.stateValues.styleDefinition)
        );
        if (child.position) {
          for (const key in theNewDef) {
            const typedKey = key;
            const value = theNewDef[typedKey];
            if (!value) {
              continue;
            }
            if (value.position === void 0) {
              value.position = child.position;
            }
          }
        }
        addMissingChildStyleColorFields(theNewDef);
        deriveMissingStyleWords(theNewDef);
        Object.assign(styleDef, theNewDef);
      }
      const diagnostics = contrastAccessibilityDiagnosticsForStyleDefinitions(
        styleDefinitions
      );
      return {
        setValue: { authoredStyleDefinitions: styleDefinitions },
        sendDiagnostics: diagnostics
      };
    }
  };
  stateVariableDefinitions.styleDefinitions = {
    returnDependencies: () => ({
      authoredStyleDefinitions: {
        dependencyType: "stateVariable",
        variableName: "authoredStyleDefinitions"
      },
      readerStyleOverrides: {
        dependencyType: "stateVariable",
        variableName: "readerStyleOverrides"
      }
    }),
    definition({ dependencyValues }) {
      if (dependencyValues.readerStyleOverrides == null) {
        return {
          setValue: {
            styleDefinitions: dependencyValues.authoredStyleDefinitions
          }
        };
      }
      const styleDefinitions = {};
      for (const styleNumber in dependencyValues.authoredStyleDefinitions) {
        styleDefinitions[styleNumber] = Object.assign(
          {},
          dependencyValues.authoredStyleDefinitions[styleNumber]
        );
      }
      applyReaderStyleOverrides(
        styleDefinitions,
        dependencyValues.readerStyleOverrides
      );
      return { setValue: { styleDefinitions } };
    }
  };
  return stateVariableDefinitions;
}
function returnSelectedStyleStateVariableDefinition(options = {}) {
  const overrideAttributeNames = options.overrideAttributeNames ?? [];
  return {
    selectedStyle: {
      forRenderer: true,
      willNeverBeEssential: true,
      returnDependencies: () => {
        const dependencies = {
          styleNumber: {
            dependencyType: "stateVariable",
            variableName: "styleNumber"
          },
          ancestorWithStyle: {
            dependencyType: "ancestor",
            variableNames: [
              "styleDefinitions",
              "activeStylePaletteName",
              "readerStyleOverrides"
            ]
          }
        };
        for (const name of overrideAttributeNames) {
          dependencies[name] = {
            dependencyType: "attributeComponent",
            attributeName: name,
            variableNames: ["value"]
          };
        }
        return dependencies;
      },
      definition: function({
        dependencyValues
      }) {
        let styleDefinitions = dependencyValues.ancestorWithStyle.stateValues.styleDefinitions;
        if (!styleDefinitions) {
          styleDefinitions = returnDefaultStyleDefinitions();
        }
        let selectedStyle = styleDefinitions[dependencyValues.styleNumber];
        if (selectedStyle === void 0) {
          const effectivePaletteName = resolveReaderPaletteName(
            dependencyValues.ancestorWithStyle?.stateValues.readerStyleOverrides
          ) ?? dependencyValues.ancestorWithStyle?.stateValues.activeStylePaletteName;
          if (effectivePaletteName != null) {
            selectedStyle = styleDefinitions[cycleStyleNumberForPalette(
              dependencyValues.styleNumber,
              effectivePaletteName
            )];
          }
        }
        if (selectedStyle === void 0) {
          selectedStyle = cloneDefaultStyleWithMissingColorWords();
        }
        if (overrideAttributeNames.length > 0) {
          const overrideStyleDef = {};
          for (const name of overrideAttributeNames) {
            const dep = dependencyValues[name];
            if (dep == null) {
              continue;
            }
            let value = dep.stateValues.value;
            if (value === void 0 || value === null) {
              continue;
            }
            if (typeof value === "string" && styleAttributes[name]?.toLowerCase) {
              value = value.toLowerCase();
            }
            setStyleValue(
              overrideStyleDef,
              name,
              value,
              dep.position
            );
          }
          if (Object.keys(overrideStyleDef).length > 0) {
            deriveMissingStyleWords(overrideStyleDef);
            selectedStyle = Object.assign(
              {},
              selectedStyle,
              overrideStyleDef
            );
          }
        }
        return {
          setValue: {
            selectedStyle: resolveStyleDefinition(
              unwrapStyleDefinition(selectedStyle)
            )
          }
        };
      }
    }
  };
}
function textRendererStyle(darkMode, selectedStyle) {
  let textColor = darkMode === "dark" ? selectedStyle.textColorDarkMode : selectedStyle.textColor;
  let backgroundColor = darkMode === "dark" ? selectedStyle.backgroundColorDarkMode : selectedStyle.backgroundColor;
  let style = {
    color: textColor
  };
  if (backgroundColor) {
    style.backgroundColor = backgroundColor;
  }
  return style;
}
function getStylePalette(name) {
  if (typeof name !== "string") {
    return null;
  }
  const paletteName = name.trim().toLowerCase();
  const palette = STYLE_PALETTES[paletteName];
  if (!palette) {
    return null;
  }
  const expanded = returnPaletteStyleDefinitions(paletteName);
  const styles = {};
  for (const styleNumber of Object.keys(expanded)) {
    styles[styleNumber] = resolveStyleDefinition(
      unwrapStyleDefinition(expanded[styleNumber])
    );
  }
  return {
    name: palette.name,
    description: palette.description,
    styles
  };
}
function getStylePalettes() {
  return STYLE_PALETTE_NAMES.map((name) => getStylePalette(name));
}
const COLOR_WORDS = {
  black: (t2, args) => t2("color.black", args, "black"),
  white: (t2, args) => t2("color.white", args, "white"),
  gray: (t2, args) => t2("color.gray", args, "gray"),
  red: (t2, args) => t2("color.red", args, "red"),
  orange: (t2, args) => t2("color.orange", args, "orange"),
  yellow: (t2, args) => t2("color.yellow", args, "yellow"),
  green: (t2, args) => t2("color.green", args, "green"),
  cyan: (t2, args) => t2("color.cyan", args, "cyan"),
  blue: (t2, args) => t2("color.blue", args, "blue"),
  purple: (t2, args) => t2("color.purple", args, "purple"),
  pink: (t2, args) => t2("color.pink", args, "pink"),
  brown: (t2, args) => t2("color.brown", args, "brown")
};
const LINE_WIDTH_WORDS = {
  thick: (t2, args) => t2("line-width.thick", args, "thick"),
  thin: (t2, args) => t2("line-width.thin", args, "thin")
};
const LINE_STYLE_WORDS = {
  dashed: (t2, args) => t2("line-style.dashed", args, "dashed"),
  dotted: (t2, args) => t2("line-style.dotted", args, "dotted")
};
const FILL_STYLE_WORDS = {
  "horizontal lines": (t2, args) => t2("fill-style.horizontal", args, "horizontal lines"),
  "vertical lines": (t2, args) => t2("fill-style.vertical", args, "vertical lines"),
  "diagonal lines": (t2, args) => t2("fill-style.diagonal", args, "diagonal lines"),
  "reverse diagonal lines": (t2, args) => t2("fill-style.backdiagonal", args, "reverse diagonal lines"),
  dots: (t2, args) => t2("fill-style.dots", args, "dots"),
  diamonds: (t2, args) => t2("fill-style.diamonds", args, "diamonds")
};
const NOUN_WORDS = {
  line: (t2) => t2("noun.line", void 0, "line"),
  "line-segment": (t2) => t2("noun.line-segment", void 0, "line segment"),
  ray: (t2) => t2("noun.ray", void 0, "ray"),
  vector: (t2) => t2("noun.vector", void 0, "vector"),
  curve: (t2) => t2("noun.curve", void 0, "curve"),
  function: (t2) => t2("noun.function", void 0, "function"),
  parabola: (t2) => t2("noun.parabola", void 0, "parabola"),
  polyline: (t2) => t2("noun.polyline", void 0, "polyline"),
  polygon: (t2) => t2("noun.polygon", void 0, "polygon"),
  triangle: (t2) => t2("noun.triangle", void 0, "triangle"),
  rectangle: (t2) => t2("noun.rectangle", void 0, "rectangle"),
  circle: (t2) => t2("noun.circle", void 0, "circle"),
  region: (t2) => t2("noun.region", void 0, "region"),
  point: (t2) => t2("noun.point", void 0, "point"),
  square: (t2) => t2("noun.square", void 0, "square"),
  diamond: (t2) => t2("noun.diamond", void 0, "diamond"),
  cross: (t2) => t2("noun.cross", void 0, "cross"),
  plus: (t2) => t2("noun.plus", void 0, "plus")
};
const MARKER_NOUN_KEYS = /* @__PURE__ */ new Set([
  "point",
  "square",
  "triangle",
  "diamond",
  "cross",
  "plus"
]);
function genderOf(t2, noun) {
  return t2("noun-gender", { noun }, "neuter");
}
function lookUp(t2, vocabulary, word, gender, role = "standalone") {
  if (!word) {
    return "";
  }
  const entry = vocabulary[word];
  return entry ? entry(t2, { gender, role }) : word;
}
function nounPhrase(t2, noun) {
  if (noun.key === "regular-polygon") {
    const { numSides } = noun;
    return {
      noun: t2(
        "noun-regular-polygon",
        { part: "head", numSides },
        `${numSides}-sided regular polygon`
      ),
      tail: t2("noun-regular-polygon", { part: "tail", numSides }, "")
    };
  }
  return { noun: NOUN_WORDS[noun.key](t2), tail: "" };
}
function markerWord(t2, markerStyleWord) {
  if (!markerStyleWord) {
    return "";
  }
  return MARKER_NOUN_KEYS.has(markerStyleWord) ? NOUN_WORDS[markerStyleWord](t2) : markerStyleWord;
}
function strokeParts(width, lineStyle, color) {
  if (width && lineStyle && color) return "width-style-color";
  if (width && color) return "width-color";
  if (lineStyle && color) return "style-color";
  if (width && lineStyle) return "width-style";
  if (width) return "width";
  if (lineStyle) return "style";
  if (color) return "color";
  return null;
}
function joinPresent(...words) {
  return words.filter(Boolean).join(" ");
}
function describeStroke(t2, words, gender, role) {
  const width = lookUp(
    t2,
    LINE_WIDTH_WORDS,
    words.lineWidthWord,
    gender,
    role
  );
  const lineStyle = lookUp(
    t2,
    LINE_STYLE_WORDS,
    words.lineStyleWord,
    gender,
    role
  );
  const color = lookUp(t2, COLOR_WORDS, words.colorWord, gender, role);
  const parts = strokeParts(width, lineStyle, color);
  if (parts === null) {
    return "";
  }
  return t2(
    "style-stroke",
    { parts, width, lineStyle, color, gender, role },
    joinPresent(width, lineStyle, color)
  );
}
function attachNoun(t2, description, { noun, tail }) {
  if (!description) {
    return joinPresent(noun, tail);
  }
  return t2(
    "style-with-noun",
    {
      parts: tail ? "noun-tail" : "noun",
      description,
      noun,
      nounTail: tail,
      // Every caller names the shape and stops there, so the phrase is
      // never governed by anything. Passed rather than left out for the
      // same reason `style-filled-word`'s is: a catalog reading `$role`
      // finds a value in every message that places adjectives.
      role: "standalone"
    },
    joinPresent(description, noun, tail)
  );
}
function describeStrokedShape(t2, words, { noun, withNoun }) {
  const stroke = describeStroke(
    t2,
    words,
    genderOf(t2, noun.key),
    "standalone"
  );
  return withNoun ? attachNoun(t2, stroke, nounPhrase(t2, noun)) : stroke;
}
function describeBorder(t2, words) {
  return describeStroke(t2, words, genderOf(t2, "border"), "standalone");
}
function describeClosedShape(t2, words, {
  filled,
  noun,
  withNoun
}) {
  if (!filled) {
    return describeStrokedShape(t2, words, { noun, withNoun });
  }
  const gender = genderOf(t2, noun.key);
  const phrase = withNoun ? nounPhrase(t2, noun) : void 0;
  const color = lookUp(t2, COLOR_WORDS, words.fillColorWord, gender);
  const pattern = lookUp(t2, FILL_STYLE_WORDS, words.fillStyleWord, gender);
  const fillParts = pattern ? "pattern" : "plain";
  const filledWord = t2(
    "style-filled-word",
    { gender, role: "standalone" },
    "filled"
  );
  const patternClause = pattern ? ` with ${pattern}` : "";
  const filledText = phrase ? t2(
    "style-filled-with-noun",
    {
      // A complement doubles the variants rather than adding a
      // placeable: a language that splits its noun has to say
      // where each half goes relative to the adjectives.
      parts: phrase.tail ? `${fillParts}-tail` : fillParts,
      color,
      pattern,
      noun: phrase.noun,
      nounTail: phrase.tail,
      filled: filledWord,
      gender,
      role: "standalone"
    },
    joinPresent(filledWord, color, phrase.noun, phrase.tail) + patternClause
  ) : t2(
    "style-filled",
    {
      parts: fillParts,
      color,
      pattern,
      filled: filledWord,
      gender,
      role: "standalone"
    },
    joinPresent(filledWord, color) + patternClause
  );
  const borderRepeatsFill = words.fillColorWord === words.colorWord;
  const borderGender = genderOf(t2, "border");
  const border = describeStroke(
    t2,
    borderRepeatsFill ? { ...words, colorWord: "" } : words,
    borderGender,
    "border-clause"
  );
  if (!border) {
    return filledText;
  }
  const connective = pattern ? "and" : "with";
  const borderParts = withNoun ? `${connective}-article` : connective;
  return filledText + " " + t2(
    "style-border-clause",
    {
      parts: borderParts,
      border,
      gender: borderGender,
      role: "border-clause"
    },
    withNoun ? `${connective} a ${border} border` : `${connective} ${border} border`
  );
}
function describeFill(t2, words, { filled }) {
  if (!filled) {
    return t2("style-unfilled", void 0, "unfilled");
  }
  const gender = genderOf(t2, "fill");
  const color = lookUp(t2, COLOR_WORDS, words.fillColorWord, gender);
  const pattern = lookUp(t2, FILL_STYLE_WORDS, words.fillStyleWord, gender);
  return t2(
    "style-fill",
    {
      parts: pattern ? "pattern" : "plain",
      color,
      pattern,
      gender,
      role: "standalone"
    },
    joinPresent(color, pattern)
  );
}
function describeMarker(t2, words, { withNoun }) {
  const noun = markerWord(t2, words.markerStyleWord);
  const gender = genderOf(t2, words.markerStyleWord || "point");
  const color = lookUp(t2, COLOR_WORDS, words.markerColorWord, gender);
  return withNoun ? attachNoun(t2, color, { noun, tail: "" }) : color;
}
function describeRegion(t2, words, { noun, withNoun }) {
  const gender = genderOf(t2, noun.key);
  const color = lookUp(t2, COLOR_WORDS, words.fillColorWord, gender);
  return withNoun ? attachNoun(t2, color, nounPhrase(t2, noun)) : color;
}
function describeColor(t2, colorWord2, head, role = "standalone") {
  return lookUp(t2, COLOR_WORDS, colorWord2, genderOf(t2, head), role);
}
function noBackgroundWord(t2) {
  return t2("style-background-none", void 0, "none");
}
function describeText(t2, { color, background }) {
  if (background === void 0) {
    return t2("style-text", { parts: "plain", color }, color);
  }
  return t2(
    "style-text",
    { parts: "background", color, background },
    `${color} with a ${background} background`
  );
}
function englishNoun(noun) {
  return noun.split("-").join(" ");
}
function commonDependencies() {
  return {
    selectedStyle: {
      dependencyType: "stateVariable",
      variableName: "selectedStyle"
    },
    document: {
      dependencyType: "ancestor",
      componentType: "document",
      variableNames: ["theme", "locale"]
    },
    getTranslator: {
      dependencyType: "translator"
    }
  };
}
function translatorFor(dependencyValues) {
  return dependencyValues.getTranslator(
    dependencyValues.document?.stateValues.locale
  );
}
function colorWord(dependencyValues, item) {
  const selectedStyle = dependencyValues.selectedStyle;
  return dependencyValues.document?.stateValues.theme === "dark" ? selectedStyle[`${item}ColorWordDarkMode`] : selectedStyle[`${item}ColorWord`];
}
function strokeWords(dependencyValues) {
  return {
    colorWord: colorWord(dependencyValues, "line"),
    lineWidthWord: dependencyValues.selectedStyle.lineWidthWord,
    lineStyleWord: dependencyValues.selectedStyle.lineStyleWord
  };
}
function closedShapeWords(dependencyValues) {
  return {
    ...strokeWords(dependencyValues),
    fillColorWord: colorWord(dependencyValues, "fill"),
    fillStyleWord: dependencyValues.selectedStyle.fillStyleWord
  };
}
function nounSpec(noun, dependencyValues) {
  return noun === "regular-polygon" ? { key: noun, numSides: dependencyValues.numSides } : { key: noun };
}
function backgroundDescription(t2, dependencyValues, role = "standalone") {
  const word = colorWord(dependencyValues, "background");
  return word ? describeColor(t2, word, "background", role) : void 0;
}
function textStateVariable(name, description, returnDependencies, compute) {
  return {
    description,
    public: true,
    shadowingInstructions: {
      createComponentOfType: "text"
    },
    returnDependencies,
    definition({ dependencyValues }) {
      return { setValue: { [name]: compute(dependencyValues) } };
    }
  };
}
function returnGraphicalStyleDescriptionDefinitions({
  kind,
  noun
}) {
  const label = englishNoun(noun);
  function dependencies() {
    const deps = commonDependencies();
    if (kind === "closedShape") {
      deps.filled = {
        dependencyType: "stateVariable",
        variableName: "filled"
      };
    }
    if (noun === "regular-polygon") {
      deps.numSides = {
        dependencyType: "stateVariable",
        variableName: "numSides"
      };
    }
    return deps;
  }
  function describe(dependencyValues, withNoun) {
    const t2 = translatorFor(dependencyValues);
    const spec = nounSpec(noun, dependencyValues);
    switch (kind) {
      case "marker":
        return describeMarker(
          t2,
          {
            markerColorWord: colorWord(dependencyValues, "marker"),
            markerStyleWord: dependencyValues.selectedStyle.markerStyleWord
          },
          { withNoun }
        );
      case "closedShape":
        return describeClosedShape(
          t2,
          closedShapeWords(dependencyValues),
          {
            filled: dependencyValues.filled,
            noun: spec,
            withNoun
          }
        );
      case "region":
        return describeRegion(
          t2,
          { fillColorWord: colorWord(dependencyValues, "fill") },
          { noun: spec, withNoun }
        );
      // `default` as well as the case it names: the components asking
      // for these definitions are `.js`, so nothing type-checks their
      // `kind`, and a stroke is the safe thing to fall back to.
      case "stroke":
      default:
        return describeStrokedShape(t2, strokeWords(dependencyValues), {
          noun: spec,
          withNoun
        });
    }
  }
  const definitions = {
    styleDescription: textStateVariable(
      "styleDescription",
      `A textual description of the ${label}'s style.`,
      dependencies,
      (dependencyValues) => describe(dependencyValues, false)
    ),
    styleDescriptionWithNoun: textStateVariable(
      "styleDescriptionWithNoun",
      `Style description including the noun "${label}".`,
      dependencies,
      (dependencyValues) => describe(dependencyValues, true)
    )
  };
  if (kind === "closedShape") {
    definitions.borderStyleDescription = textStateVariable(
      "borderStyleDescription",
      `A textual description of the ${label}'s border style.`,
      dependencies,
      (dependencyValues) => describeBorder(
        translatorFor(dependencyValues),
        strokeWords(dependencyValues)
      )
    );
    definitions.fillStyleDescription = textStateVariable(
      "fillStyleDescription",
      `A textual description of the ${label}'s fill style.`,
      dependencies,
      (dependencyValues) => describeFill(
        translatorFor(dependencyValues),
        {
          fillColorWord: colorWord(dependencyValues, "fill"),
          fillStyleWord: dependencyValues.selectedStyle.fillStyleWord
        },
        { filled: dependencyValues.filled }
      )
    );
  }
  return definitions;
}
function returnTextStyleDescriptionDefinitions() {
  return {
    textColor: textStateVariable(
      "textColor",
      "Human-readable name for this component's text color, derived from the active style and theme.",
      commonDependencies,
      (dependencyValues) => describeColor(
        translatorFor(dependencyValues),
        colorWord(dependencyValues, "text"),
        "text"
      )
    ),
    backgroundColor: textStateVariable(
      "backgroundColor",
      "Human-readable name for this component's background color, derived from the active style and theme.",
      commonDependencies,
      (dependencyValues) => {
        const t2 = translatorFor(dependencyValues);
        return backgroundDescription(t2, dependencyValues) ?? noBackgroundWord(t2);
      }
    ),
    // Reads the raw style rather than the two variables above, since
    // `backgroundColor` reports a translated "none" that this cannot
    // usefully compare against.
    textStyleDescription: textStateVariable(
      "textStyleDescription",
      "Human-readable description of this component's text styling (color and any background color).",
      commonDependencies,
      (dependencyValues) => {
        const t2 = translatorFor(dependencyValues);
        return describeText(t2, {
          color: describeColor(
            t2,
            colorWord(dependencyValues, "text"),
            "text",
            "text-clause"
          ),
          background: backgroundDescription(
            t2,
            dependencyValues,
            "background-clause"
          )
        });
      }
    )
  };
}
export {
  resolveColorWord as $,
  describeStrokedShape as A,
  describeText as B,
  CANVAS_DARK_MODE_COLOR as C,
  DEFAULT_PALETTE_NAME as D,
  encodeFillPatternColorToken as E,
  expandStylePalette as F,
  GRAPHIC_CONTRAST_THRESHOLD as G,
  fillOverrideAttributes as H,
  getStylePalette as I,
  getStylePalettes as J,
  getStyleValueNumber as K,
  getStyleValueString as L,
  grayscalePalette as M,
  grumpyNarwhalPalette as N,
  ibmPalette as O,
  invertLightness as P,
  isStyleValueWithPosition as Q,
  latestPosition as R,
  STYLE_OVERRIDE_CATEGORIES as S,
  TEXT_CONTRAST_THRESHOLD as T,
  lineOverrideAttributes as U,
  markerOverrideAttributes as V,
  markerStyleValuesWithFillVariants as W,
  noBackgroundWord as X,
  normalizeStyleDefinitionValues as Y,
  normalizeStyleDefinitionsValues as Z,
  okabeItoPalette as _,
  CANVAS_LIGHT_MODE_COLOR as a,
  resolveReaderPaletteName as a0,
  resolveStyleDefinition as a1,
  returnDefaultStyleDefinitions as a2,
  returnGraphicalStyleDescriptionDefinitions as a3,
  returnPaletteStyleDefinitions as a4,
  returnSelectedStyleStateVariableDefinition as a5,
  returnStyleDefinitionStateVariables as a6,
  returnTextStyleDescriptionDefinitions as a7,
  setStyleValue as a8,
  styleAttributes as a9,
  styleOverrideAttributes as aa,
  suggestAccessibleDarkModeColorAgainst as ab,
  textRendererStyle as ac,
  tolBrightPalette as ad,
  tolHighContrastPalette as ae,
  tolMutedPalette as af,
  unwrapStyleDefinition as ag,
  getDefaultExportFromCjs as ah,
  commonjsGlobal as ai,
  codedDiagnostic as aj,
  CANVAS_TEXT_DARK_MODE_COLOR as b,
  CANVAS_TEXT_LIGHT_MODE_COLOR as c,
  DEFAULT_STYLE_VALUES as d,
  STYLE_PALETTES as e,
  STYLE_PALETTE_NAMES as f,
  addMissingChildStyleColorFields as g,
  applyReaderStyleOverrides as h,
  attributeSpecFromStyleAttribute as i,
  categoricalPalette as j,
  colorValueToWord as k,
  coloredItemsForWords as l,
  compositedContrastRatio as m,
  contrastAccessibilityDiagnosticsForStyleDefinitions as n,
  cycleStyleNumberForPalette as o,
  decodeFillPatternColorToken as p,
  defaultPalette as q,
  deriveAccessibleDarkModeBackground as r,
  deriveAccessibleDarkModeColor as s,
  deriveMissingStyleWords as t,
  describeBorder as u,
  describeClosedShape as v,
  describeColor as w,
  describeFill as x,
  describeMarker as y,
  describeRegion as z
};
//# sourceMappingURL=styleDescriptionDefinitions-RiebHJ4R.js.map
